import { defineComponent, openBlock, createBlock, createVNode } from 'vue';

var script = defineComponent({
  name: 'OCalculator'
});

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}

script.render = render;
script.__file = "lib/components/Icons/Outline/OCalculator.vue";

var script$1 = defineComponent({
  name: 'OFlag'
});

const _hoisted_1$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
}, null, -1 /* HOISTED */);

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1, [
    _hoisted_2$1
  ]))
}

script$1.render = render$1;
script$1.__file = "lib/components/Icons/Outline/OFlag.vue";

var script$2 = defineComponent({
  name: 'ONewspaper'
});

const _hoisted_1$2 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
}, null, -1 /* HOISTED */);

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2, [
    _hoisted_2$2
  ]))
}

script$2.render = render$2;
script$2.__file = "lib/components/Icons/Outline/ONewspaper.vue";

var script$3 = defineComponent({
  name: 'ODatabase'
});

const _hoisted_1$3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
}, null, -1 /* HOISTED */);

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3, [
    _hoisted_2$3
  ]))
}

script$3.render = render$3;
script$3.__file = "lib/components/Icons/Outline/ODatabase.vue";

var script$4 = defineComponent({
  name: 'OVideoCamera'
});

const _hoisted_1$4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$4 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4, [
    _hoisted_2$4
  ]))
}

script$4.render = render$4;
script$4.__file = "lib/components/Icons/Outline/OVideoCamera.vue";

var script$5 = defineComponent({
  name: 'OAcademicCap'
});

const _hoisted_1$5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$5 = /*#__PURE__*/createVNode("path", {
  fill: "#fff",
  d: "M12 14l9-5-9-5-9 5 9 5z"
}, null, -1 /* HOISTED */);
const _hoisted_3 = /*#__PURE__*/createVNode("path", {
  fill: "#fff",
  d: "M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
}, null, -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
}, null, -1 /* HOISTED */);

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5, [
    _hoisted_2$5,
    _hoisted_3,
    _hoisted_4
  ]))
}

script$5.render = render$5;
script$5.__file = "lib/components/Icons/Outline/OAcademicCap.vue";

var script$6 = defineComponent({
  name: 'OBriefcase'
});

const _hoisted_1$6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$6 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6, [
    _hoisted_2$6
  ]))
}

script$6.render = render$6;
script$6.__file = "lib/components/Icons/Outline/OBriefcase.vue";

var script$7 = defineComponent({
  name: 'OMenuAlt4'
});

const _hoisted_1$7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$7 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 8h16M4 16h16"
}, null, -1 /* HOISTED */);

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$7, [
    _hoisted_2$7
  ]))
}

script$7.render = render$7;
script$7.__file = "lib/components/Icons/Outline/OMenuAlt4.vue";

var script$8 = defineComponent({
  name: 'OTag'
});

const _hoisted_1$8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$8 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
}, null, -1 /* HOISTED */);

function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$8, [
    _hoisted_2$8
  ]))
}

script$8.render = render$8;
script$8.__file = "lib/components/Icons/Outline/OTag.vue";

var script$9 = defineComponent({
  name: 'OUserAdd'
});

const _hoisted_1$9 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$9 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
}, null, -1 /* HOISTED */);

function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$9, [
    _hoisted_2$9
  ]))
}

script$9.render = render$9;
script$9.__file = "lib/components/Icons/Outline/OUserAdd.vue";

var script$a = defineComponent({
  name: 'OMap'
});

const _hoisted_1$a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$a = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
}, null, -1 /* HOISTED */);

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$a, [
    _hoisted_2$a
  ]))
}

script$a.render = render$a;
script$a.__file = "lib/components/Icons/Outline/OMap.vue";

var script$b = defineComponent({
  name: 'OColorSwatch'
});

const _hoisted_1$b = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$b = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
}, null, -1 /* HOISTED */);

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$b, [
    _hoisted_2$b
  ]))
}

script$b.render = render$b;
script$b.__file = "lib/components/Icons/Outline/OColorSwatch.vue";

var script$c = defineComponent({
  name: 'OCurrencyRupee'
});

const _hoisted_1$c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$c = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$c, [
    _hoisted_2$c
  ]))
}

script$c.render = render$c;
script$c.__file = "lib/components/Icons/Outline/OCurrencyRupee.vue";

var script$d = defineComponent({
  name: 'ORss'
});

const _hoisted_1$d = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$d = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"
}, null, -1 /* HOISTED */);

function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$d, [
    _hoisted_2$d
  ]))
}

script$d.render = render$d;
script$d.__file = "lib/components/Icons/Outline/ORss.vue";

var script$e = defineComponent({
  name: 'OArrowNarrowUp'
});

const _hoisted_1$e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$e = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 7l4-4m0 0l4 4m-4-4v18"
}, null, -1 /* HOISTED */);

function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$e, [
    _hoisted_2$e
  ]))
}

script$e.render = render$e;
script$e.__file = "lib/components/Icons/Outline/OArrowNarrowUp.vue";

var script$f = defineComponent({
  name: 'OCamera'
});

const _hoisted_1$f = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$f = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
}, null, -1 /* HOISTED */);
const _hoisted_3$1 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
}, null, -1 /* HOISTED */);

function render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$f, [
    _hoisted_2$f,
    _hoisted_3$1
  ]))
}

script$f.render = render$f;
script$f.__file = "lib/components/Icons/Outline/OCamera.vue";

var script$g = defineComponent({
  name: 'OPlusSm'
});

const _hoisted_1$g = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$g = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
}, null, -1 /* HOISTED */);

function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$g, [
    _hoisted_2$g
  ]))
}

script$g.render = render$g;
script$g.__file = "lib/components/Icons/Outline/OPlusSm.vue";

var script$h = defineComponent({
  name: 'OArrowCircleDown'
});

const _hoisted_1$h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$h = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
}, null, -1 /* HOISTED */);

function render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$h, [
    _hoisted_2$h
  ]))
}

script$h.render = render$h;
script$h.__file = "lib/components/Icons/Outline/OArrowCircleDown.vue";

var script$i = defineComponent({
  name: 'OFilter'
});

const _hoisted_1$i = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$i = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
}, null, -1 /* HOISTED */);

function render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$i, [
    _hoisted_2$i
  ]))
}

script$i.render = render$i;
script$i.__file = "lib/components/Icons/Outline/OFilter.vue";

var script$j = defineComponent({
  name: 'OPhoneMissedCall'
});

const _hoisted_1$j = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$j = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
}, null, -1 /* HOISTED */);

function render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$j, [
    _hoisted_2$j
  ]))
}

script$j.render = render$j;
script$j.__file = "lib/components/Icons/Outline/OPhoneMissedCall.vue";

var script$k = defineComponent({
  name: 'OLockOpen'
});

const _hoisted_1$k = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$k = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$k, [
    _hoisted_2$k
  ]))
}

script$k.render = render$k;
script$k.__file = "lib/components/Icons/Outline/OLockOpen.vue";

var script$l = defineComponent({
  name: 'OTemplate'
});

const _hoisted_1$l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$l = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
}, null, -1 /* HOISTED */);

function render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$l, [
    _hoisted_2$l
  ]))
}

script$l.render = render$l;
script$l.__file = "lib/components/Icons/Outline/OTemplate.vue";

var script$m = defineComponent({
  name: 'ODocumentDownload'
});

const _hoisted_1$m = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$m = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
}, null, -1 /* HOISTED */);

function render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$m, [
    _hoisted_2$m
  ]))
}

script$m.render = render$m;
script$m.__file = "lib/components/Icons/Outline/ODocumentDownload.vue";

var script$n = defineComponent({
  name: 'OFilm'
});

const _hoisted_1$n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$n = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"
}, null, -1 /* HOISTED */);

function render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$n, [
    _hoisted_2$n
  ]))
}

script$n.render = render$n;
script$n.__file = "lib/components/Icons/Outline/OFilm.vue";

var script$o = defineComponent({
  name: 'OOfficeBuilding'
});

const _hoisted_1$o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$o = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
}, null, -1 /* HOISTED */);

function render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$o, [
    _hoisted_2$o
  ]))
}

script$o.render = render$o;
script$o.__file = "lib/components/Icons/Outline/OOfficeBuilding.vue";

var script$p = defineComponent({
  name: 'OReceiptTax'
});

const _hoisted_1$p = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$p = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"
}, null, -1 /* HOISTED */);

function render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$p, [
    _hoisted_2$p
  ]))
}

script$p.render = render$p;
script$p.__file = "lib/components/Icons/Outline/OReceiptTax.vue";

var script$q = defineComponent({
  name: 'OReply'
});

const _hoisted_1$q = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$q = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
}, null, -1 /* HOISTED */);

function render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$q, [
    _hoisted_2$q
  ]))
}

script$q.render = render$q;
script$q.__file = "lib/components/Icons/Outline/OReply.vue";

var script$r = defineComponent({
  name: 'OPause'
});

const _hoisted_1$r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$r = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$r, [
    _hoisted_2$r
  ]))
}

script$r.render = render$r;
script$r.__file = "lib/components/Icons/Outline/OPause.vue";

var script$s = defineComponent({
  name: 'OSave'
});

const _hoisted_1$s = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$s = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
}, null, -1 /* HOISTED */);

function render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$s, [
    _hoisted_2$s
  ]))
}

script$s.render = render$s;
script$s.__file = "lib/components/Icons/Outline/OSave.vue";

var script$t = defineComponent({
  name: 'OStop'
});

const _hoisted_1$t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$t = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);
const _hoisted_3$2 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
}, null, -1 /* HOISTED */);

function render$t(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$t, [
    _hoisted_2$t,
    _hoisted_3$2
  ]))
}

script$t.render = render$t;
script$t.__file = "lib/components/Icons/Outline/OStop.vue";

var script$u = defineComponent({
  name: 'OServer'
});

const _hoisted_1$u = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$u = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
}, null, -1 /* HOISTED */);

function render$u(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$u, [
    _hoisted_2$u
  ]))
}

script$u.render = render$u;
script$u.__file = "lib/components/Icons/Outline/OServer.vue";

var script$v = defineComponent({
  name: 'OWifi'
});

const _hoisted_1$v = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$v = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
}, null, -1 /* HOISTED */);

function render$v(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$v, [
    _hoisted_2$v
  ]))
}

script$v.render = render$v;
script$v.__file = "lib/components/Icons/Outline/OWifi.vue";

var script$w = defineComponent({
  name: 'OEyeOff'
});

const _hoisted_1$w = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$w = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
}, null, -1 /* HOISTED */);

function render$w(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$w, [
    _hoisted_2$w
  ]))
}

script$w.render = render$w;
script$w.__file = "lib/components/Icons/Outline/OEyeOff.vue";

var script$x = defineComponent({
  name: 'OEmojiHappy'
});

const _hoisted_1$x = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$x = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$x(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$x, [
    _hoisted_2$x
  ]))
}

script$x.render = render$x;
script$x.__file = "lib/components/Icons/Outline/OEmojiHappy.vue";

var script$y = defineComponent({
  name: 'OCalendar'
});

const _hoisted_1$y = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$y = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$y, [
    _hoisted_2$y
  ]))
}

script$y.render = render$y;
script$y.__file = "lib/components/Icons/Outline/OCalendar.vue";

var script$z = defineComponent({
  name: 'OFingerPrint'
});

const _hoisted_1$z = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$z = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
}, null, -1 /* HOISTED */);

function render$z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$z, [
    _hoisted_2$z
  ]))
}

script$z.render = render$z;
script$z.__file = "lib/components/Icons/Outline/OFingerPrint.vue";

var script$A = defineComponent({
  name: 'OClock'
});

const _hoisted_1$A = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$A = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$A(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$A, [
    _hoisted_2$A
  ]))
}

script$A.render = render$A;
script$A.__file = "lib/components/Icons/Outline/OClock.vue";

var script$B = defineComponent({
  name: 'OMoon'
});

const _hoisted_1$B = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$B = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
}, null, -1 /* HOISTED */);

function render$B(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$B, [
    _hoisted_2$B
  ]))
}

script$B.render = render$B;
script$B.__file = "lib/components/Icons/Outline/OMoon.vue";

var script$C = defineComponent({
  name: 'OPlay'
});

const _hoisted_1$C = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$C = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
}, null, -1 /* HOISTED */);
const _hoisted_3$3 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$C(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$C, [
    _hoisted_2$C,
    _hoisted_3$3
  ]))
}

script$C.render = render$C;
script$C.__file = "lib/components/Icons/Outline/OPlay.vue";

var script$D = defineComponent({
  name: 'OArrowCircleRight'
});

const _hoisted_1$D = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$D = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$D(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$D, [
    _hoisted_2$D
  ]))
}

script$D.render = render$D;
script$D.__file = "lib/components/Icons/Outline/OArrowCircleRight.vue";

var script$E = defineComponent({
  name: 'OSearchCircle'
});

const _hoisted_1$E = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$E = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$E(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$E, [
    _hoisted_2$E
  ]))
}

script$E.render = render$E;
script$E.__file = "lib/components/Icons/Outline/OSearchCircle.vue";

var script$F = defineComponent({
  name: 'OAtSymbol'
});

const _hoisted_1$F = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$F = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
}, null, -1 /* HOISTED */);

function render$F(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$F, [
    _hoisted_2$F
  ]))
}

script$F.render = render$F;
script$F.__file = "lib/components/Icons/Outline/OAtSymbol.vue";

var script$G = defineComponent({
  name: 'OPrinter'
});

const _hoisted_1$G = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$G = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
}, null, -1 /* HOISTED */);

function render$G(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$G, [
    _hoisted_2$G
  ]))
}

script$G.render = render$G;
script$G.__file = "lib/components/Icons/Outline/OPrinter.vue";

var script$H = defineComponent({
  name: 'OMicrophone'
});

const _hoisted_1$H = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$H = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
}, null, -1 /* HOISTED */);

function render$H(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$H, [
    _hoisted_2$H
  ]))
}

script$H.render = render$H;
script$H.__file = "lib/components/Icons/Outline/OMicrophone.vue";

var script$I = defineComponent({
  name: 'ORewind'
});

const _hoisted_1$I = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$I = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z"
}, null, -1 /* HOISTED */);

function render$I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$I, [
    _hoisted_2$I
  ]))
}

script$I.render = render$I;
script$I.__file = "lib/components/Icons/Outline/ORewind.vue";

var script$J = defineComponent({
  name: 'OLocationMarker'
});

const _hoisted_1$J = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$J = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
}, null, -1 /* HOISTED */);
const _hoisted_3$4 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
}, null, -1 /* HOISTED */);

function render$J(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$J, [
    _hoisted_2$J,
    _hoisted_3$4
  ]))
}

script$J.render = render$J;
script$J.__file = "lib/components/Icons/Outline/OLocationMarker.vue";

var script$K = defineComponent({
  name: 'OHeart'
});

const _hoisted_1$K = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$K = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
}, null, -1 /* HOISTED */);

function render$K(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$K, [
    _hoisted_2$K
  ]))
}

script$K.render = render$K;
script$K.__file = "lib/components/Icons/Outline/OHeart.vue";

var script$L = defineComponent({
  name: 'OTrendingUp'
});

const _hoisted_1$L = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$L = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
}, null, -1 /* HOISTED */);

function render$L(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$L, [
    _hoisted_2$L
  ]))
}

script$L.render = render$L;
script$L.__file = "lib/components/Icons/Outline/OTrendingUp.vue";

var script$M = defineComponent({
  name: 'OMinus'
});

const _hoisted_1$M = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$M = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20 12H4"
}, null, -1 /* HOISTED */);

function render$M(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$M, [
    _hoisted_2$M
  ]))
}

script$M.render = render$M;
script$M.__file = "lib/components/Icons/Outline/OMinus.vue";

var script$N = defineComponent({
  name: 'ODeviceTablet'
});

const _hoisted_1$N = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$N = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$N(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$N, [
    _hoisted_2$N
  ]))
}

script$N.render = render$N;
script$N.__file = "lib/components/Icons/Outline/ODeviceTablet.vue";

var script$O = defineComponent({
  name: 'OSearch'
});

const _hoisted_1$O = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$O = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
}, null, -1 /* HOISTED */);

function render$O(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$O, [
    _hoisted_2$O
  ]))
}

script$O.render = render$O;
script$O.__file = "lib/components/Icons/Outline/OSearch.vue";

var script$P = defineComponent({
  name: 'OScale'
});

const _hoisted_1$P = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$P = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
}, null, -1 /* HOISTED */);

function render$P(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$P, [
    _hoisted_2$P
  ]))
}

script$P.render = render$P;
script$P.__file = "lib/components/Icons/Outline/OScale.vue";

var script$Q = defineComponent({
  name: 'OChip'
});

const _hoisted_1$Q = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$Q = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
}, null, -1 /* HOISTED */);

function render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$Q, [
    _hoisted_2$Q
  ]))
}

script$Q.render = render$Q;
script$Q.__file = "lib/components/Icons/Outline/OChip.vue";

var script$R = defineComponent({
  name: 'OCloudUpload'
});

const _hoisted_1$R = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$R = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
}, null, -1 /* HOISTED */);

function render$R(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$R, [
    _hoisted_2$R
  ]))
}

script$R.render = render$R;
script$R.__file = "lib/components/Icons/Outline/OCloudUpload.vue";

var script$S = defineComponent({
  name: 'OPlusCircle'
});

const _hoisted_1$S = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$S = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$S(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$S, [
    _hoisted_2$S
  ]))
}

script$S.render = render$S;
script$S.__file = "lib/components/Icons/Outline/OPlusCircle.vue";

var script$T = defineComponent({
  name: 'OCurrencyYen'
});

const _hoisted_1$T = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$T = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 8l3 5m0 0l3-5m-3 5v4m-3-5h6m-6 3h6m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$T, [
    _hoisted_2$T
  ]))
}

script$T.render = render$T;
script$T.__file = "lib/components/Icons/Outline/OCurrencyYen.vue";

var script$U = defineComponent({
  name: 'OSpeakerphone'
});

const _hoisted_1$U = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$U = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
}, null, -1 /* HOISTED */);

function render$U(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$U, [
    _hoisted_2$U
  ]))
}

script$U.render = render$U;
script$U.__file = "lib/components/Icons/Outline/OSpeakerphone.vue";

var script$V = defineComponent({
  name: 'OTruck'
});

const _hoisted_1$V = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$V = /*#__PURE__*/createVNode("path", {
  fill: "#fff",
  d: "M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
}, null, -1 /* HOISTED */);
const _hoisted_3$5 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
}, null, -1 /* HOISTED */);

function render$V(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$V, [
    _hoisted_2$V,
    _hoisted_3$5
  ]))
}

script$V.render = render$V;
script$V.__file = "lib/components/Icons/Outline/OTruck.vue";

var script$W = defineComponent({
  name: 'OFolderAdd'
});

const _hoisted_1$W = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$W = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
}, null, -1 /* HOISTED */);

function render$W(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$W, [
    _hoisted_2$W
  ]))
}

script$W.render = render$W;
script$W.__file = "lib/components/Icons/Outline/OFolderAdd.vue";

var script$X = defineComponent({
  name: 'OEye'
});

const _hoisted_1$X = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$X = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
}, null, -1 /* HOISTED */);
const _hoisted_3$6 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
}, null, -1 /* HOISTED */);

function render$X(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$X, [
    _hoisted_2$X,
    _hoisted_3$6
  ]))
}

script$X.render = render$X;
script$X.__file = "lib/components/Icons/Outline/OEye.vue";

var script$Y = defineComponent({
  name: 'OPencil'
});

const _hoisted_1$Y = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$Y = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
}, null, -1 /* HOISTED */);

function render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$Y, [
    _hoisted_2$Y
  ]))
}

script$Y.render = render$Y;
script$Y.__file = "lib/components/Icons/Outline/OPencil.vue";

var script$Z = defineComponent({
  name: 'OCurrencyEuro'
});

const _hoisted_1$Z = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$Z = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$Z, [
    _hoisted_2$Z
  ]))
}

script$Z.render = render$Z;
script$Z.__file = "lib/components/Icons/Outline/OCurrencyEuro.vue";

var script$_ = defineComponent({
  name: 'OGift'
});

const _hoisted_1$_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$_ = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
}, null, -1 /* HOISTED */);

function render$_(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$_, [
    _hoisted_2$_
  ]))
}

script$_.render = render$_;
script$_.__file = "lib/components/Icons/Outline/OGift.vue";

var script$$ = defineComponent({
  name: 'OChevronDoubleDown'
});

const _hoisted_1$$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$$ = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 13l-7 7-7-7m14-8l-7 7-7-7"
}, null, -1 /* HOISTED */);

function render$$(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$$, [
    _hoisted_2$$
  ]))
}

script$$.render = render$$;
script$$.__file = "lib/components/Icons/Outline/OChevronDoubleDown.vue";

var script$10 = defineComponent({
  name: 'OCube'
});

const _hoisted_1$10 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$10 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
}, null, -1 /* HOISTED */);

function render$10(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$10, [
    _hoisted_2$10
  ]))
}

script$10.render = render$10;
script$10.__file = "lib/components/Icons/Outline/OCube.vue";

var script$11 = defineComponent({
  name: 'ODocumentReport'
});

const _hoisted_1$11 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$11 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
}, null, -1 /* HOISTED */);

function render$11(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$11, [
    _hoisted_2$11
  ]))
}

script$11.render = render$11;
script$11.__file = "lib/components/Icons/Outline/ODocumentReport.vue";

var script$12 = defineComponent({
  name: 'ODocumentSearch'
});

const _hoisted_1$12 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$12 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"
}, null, -1 /* HOISTED */);

function render$12(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$12, [
    _hoisted_2$12
  ]))
}

script$12.render = render$12;
script$12.__file = "lib/components/Icons/Outline/ODocumentSearch.vue";

var script$13 = defineComponent({
  name: 'ODesktopComputer'
});

const _hoisted_1$13 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$13 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$13(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$13, [
    _hoisted_2$13
  ]))
}

script$13.render = render$13;
script$13.__file = "lib/components/Icons/Outline/ODesktopComputer.vue";

var script$14 = defineComponent({
  name: 'OArrowCircleLeft'
});

const _hoisted_1$14 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$14 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
}, null, -1 /* HOISTED */);

function render$14(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$14, [
    _hoisted_2$14
  ]))
}

script$14.render = render$14;
script$14.__file = "lib/components/Icons/Outline/OArrowCircleLeft.vue";

var script$15 = defineComponent({
  name: 'OArrowNarrowDown'
});

const _hoisted_1$15 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$15 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 17l-4 4m0 0l-4-4m4 4V3"
}, null, -1 /* HOISTED */);

function render$15(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$15, [
    _hoisted_2$15
  ]))
}

script$15.render = render$15;
script$15.__file = "lib/components/Icons/Outline/OArrowNarrowDown.vue";

var script$16 = defineComponent({
  name: 'OAdjustments'
});

const _hoisted_1$16 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$16 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
}, null, -1 /* HOISTED */);

function render$16(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$16, [
    _hoisted_2$16
  ]))
}

script$16.render = render$16;
script$16.__file = "lib/components/Icons/Outline/OAdjustments.vue";

var script$17 = defineComponent({
  name: 'OSwitchVertical'
});

const _hoisted_1$17 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$17 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
}, null, -1 /* HOISTED */);

function render$17(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$17, [
    _hoisted_2$17
  ]))
}

script$17.render = render$17;
script$17.__file = "lib/components/Icons/Outline/OSwitchVertical.vue";

var script$18 = defineComponent({
  name: 'OMail'
});

const _hoisted_1$18 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$18 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$18(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$18, [
    _hoisted_2$18
  ]))
}

script$18.render = render$18;
script$18.__file = "lib/components/Icons/Outline/OMail.vue";

var script$19 = defineComponent({
  name: 'OHashtag'
});

const _hoisted_1$19 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$19 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
}, null, -1 /* HOISTED */);

function render$19(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$19, [
    _hoisted_2$19
  ]))
}

script$19.render = render$19;
script$19.__file = "lib/components/Icons/Outline/OHashtag.vue";

var script$1a = defineComponent({
  name: 'OCurrencyDollar'
});

const _hoisted_1$1a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1a = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$1a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1a, [
    _hoisted_2$1a
  ]))
}

script$1a.render = render$1a;
script$1a.__file = "lib/components/Icons/Outline/OCurrencyDollar.vue";

var script$1b = defineComponent({
  name: 'OSortDescending'
});

const _hoisted_1$1b = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1b = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
}, null, -1 /* HOISTED */);

function render$1b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1b, [
    _hoisted_2$1b
  ]))
}

script$1b.render = render$1b;
script$1b.__file = "lib/components/Icons/Outline/OSortDescending.vue";

var script$1c = defineComponent({
  name: 'OMenuAlt2'
});

const _hoisted_1$1c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1c = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h7"
}, null, -1 /* HOISTED */);

function render$1c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1c, [
    _hoisted_2$1c
  ]))
}

script$1c.render = render$1c;
script$1c.__file = "lib/components/Icons/Outline/OMenuAlt2.vue";

var script$1d = defineComponent({
  name: 'OChartSquareBar'
});

const _hoisted_1$1d = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1d = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$1d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1d, [
    _hoisted_2$1d
  ]))
}

script$1d.render = render$1d;
script$1d.__file = "lib/components/Icons/Outline/OChartSquareBar.vue";

var script$1e = defineComponent({
  name: 'OArchive'
});

const _hoisted_1$1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1e = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
}, null, -1 /* HOISTED */);

function render$1e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1e, [
    _hoisted_2$1e
  ]))
}

script$1e.render = render$1e;
script$1e.__file = "lib/components/Icons/Outline/OArchive.vue";

var script$1f = defineComponent({
  name: 'OMusicNote'
});

const _hoisted_1$1f = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1f = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
}, null, -1 /* HOISTED */);

function render$1f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1f, [
    _hoisted_2$1f
  ]))
}

script$1f.render = render$1f;
script$1f.__file = "lib/components/Icons/Outline/OMusicNote.vue";

var script$1g = defineComponent({
  name: 'OPresentationChartLine'
});

const _hoisted_1$1g = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1g = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
}, null, -1 /* HOISTED */);

function render$1g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1g, [
    _hoisted_2$1g
  ]))
}

script$1g.render = render$1g;
script$1g.__file = "lib/components/Icons/Outline/OPresentationChartLine.vue";

var script$1h = defineComponent({
  name: 'OViewBoards'
});

const _hoisted_1$1h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1h = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"
}, null, -1 /* HOISTED */);

function render$1h(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1h, [
    _hoisted_2$1h
  ]))
}

script$1h.render = render$1h;
script$1h.__file = "lib/components/Icons/Outline/OViewBoards.vue";

var script$1i = defineComponent({
  name: 'OMenuAlt1'
});

const _hoisted_1$1i = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1i = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h8m-8 6h16"
}, null, -1 /* HOISTED */);

function render$1i(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1i, [
    _hoisted_2$1i
  ]))
}

script$1i.render = render$1i;
script$1i.__file = "lib/components/Icons/Outline/OMenuAlt1.vue";

var script$1j = defineComponent({
  name: 'OKey'
});

const _hoisted_1$1j = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1j = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
}, null, -1 /* HOISTED */);

function render$1j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1j, [
    _hoisted_2$1j
  ]))
}

script$1j.render = render$1j;
script$1j.__file = "lib/components/Icons/Outline/OKey.vue";

var script$1k = defineComponent({
  name: 'OCollection'
});

const _hoisted_1$1k = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1k = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
}, null, -1 /* HOISTED */);

function render$1k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1k, [
    _hoisted_2$1k
  ]))
}

script$1k.render = render$1k;
script$1k.__file = "lib/components/Icons/Outline/OCollection.vue";

var script$1l = defineComponent({
  name: 'OReceiptRefund'
});

const _hoisted_1$1l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1l = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"
}, null, -1 /* HOISTED */);

function render$1l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1l, [
    _hoisted_2$1l
  ]))
}

script$1l.render = render$1l;
script$1l.__file = "lib/components/Icons/Outline/OReceiptRefund.vue";

var script$1m = defineComponent({
  name: 'OCode'
});

const _hoisted_1$1m = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1m = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
}, null, -1 /* HOISTED */);

function render$1m(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1m, [
    _hoisted_2$1m
  ]))
}

script$1m.render = render$1m;
script$1m.__file = "lib/components/Icons/Outline/OCode.vue";

var script$1n = defineComponent({
  name: 'OViewList'
});

const _hoisted_1$1n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1n = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 10h16M4 14h16M4 18h16"
}, null, -1 /* HOISTED */);

function render$1n(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1n, [
    _hoisted_2$1n
  ]))
}

script$1n.render = render$1n;
script$1n.__file = "lib/components/Icons/Outline/OViewList.vue";

var script$1o = defineComponent({
  name: 'OLink'
});

const _hoisted_1$1o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1o = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
}, null, -1 /* HOISTED */);

function render$1o(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1o, [
    _hoisted_2$1o
  ]))
}

script$1o.render = render$1o;
script$1o.__file = "lib/components/Icons/Outline/OLink.vue";

var script$1p = defineComponent({
  name: 'OChatAlt'
});

const _hoisted_1$1p = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1p = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
}, null, -1 /* HOISTED */);

function render$1p(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1p, [
    _hoisted_2$1p
  ]))
}

script$1p.render = render$1p;
script$1p.__file = "lib/components/Icons/Outline/OChatAlt.vue";

var script$1q = defineComponent({
  name: 'OArrowDown'
});

const _hoisted_1$1q = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1q = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 14l-7 7m0 0l-7-7m7 7V3"
}, null, -1 /* HOISTED */);

function render$1q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1q, [
    _hoisted_2$1q
  ]))
}

script$1q.render = render$1q;
script$1q.__file = "lib/components/Icons/Outline/OArrowDown.vue";

var script$1r = defineComponent({
  name: 'OChevronDoubleUp'
});

const _hoisted_1$1r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1r = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 11l7-7 7 7M5 19l7-7 7 7"
}, null, -1 /* HOISTED */);

function render$1r(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1r, [
    _hoisted_2$1r
  ]))
}

script$1r.render = render$1r;
script$1r.__file = "lib/components/Icons/Outline/OChevronDoubleUp.vue";

var script$1s = defineComponent({
  name: 'OStatusOffline'
});

const _hoisted_1$1s = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1s = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
}, null, -1 /* HOISTED */);

function render$1s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1s, [
    _hoisted_2$1s
  ]))
}

script$1s.render = render$1s;
script$1s.__file = "lib/components/Icons/Outline/OStatusOffline.vue";

var script$1t = defineComponent({
  name: 'OPhotograph'
});

const _hoisted_1$1t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1t = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$1t(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1t, [
    _hoisted_2$1t
  ]))
}

script$1t.render = render$1t;
script$1t.__file = "lib/components/Icons/Outline/OPhotograph.vue";

var script$1u = defineComponent({
  name: 'OCreditCard'
});

const _hoisted_1$1u = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1u = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
}, null, -1 /* HOISTED */);

function render$1u(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1u, [
    _hoisted_2$1u
  ]))
}

script$1u.render = render$1u;
script$1u.__file = "lib/components/Icons/Outline/OCreditCard.vue";

var script$1v = defineComponent({
  name: 'OViewGrid'
});

const _hoisted_1$1v = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1v = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
}, null, -1 /* HOISTED */);

function render$1v(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1v, [
    _hoisted_2$1v
  ]))
}

script$1v.render = render$1v;
script$1v.__file = "lib/components/Icons/Outline/OViewGrid.vue";

var script$1w = defineComponent({
  name: 'OQrcode'
});

const _hoisted_1$1w = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1w = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
}, null, -1 /* HOISTED */);

function render$1w(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1w, [
    _hoisted_2$1w
  ]))
}

script$1w.render = render$1w;
script$1w.__file = "lib/components/Icons/Outline/OQrcode.vue";

var script$1x = defineComponent({
  name: 'OLogout'
});

const _hoisted_1$1x = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1x = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
}, null, -1 /* HOISTED */);

function render$1x(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1x, [
    _hoisted_2$1x
  ]))
}

script$1x.render = render$1x;
script$1x.__file = "lib/components/Icons/Outline/OLogout.vue";

var script$1y = defineComponent({
  name: 'ODotsHorizontal'
});

const _hoisted_1$1y = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1y = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
}, null, -1 /* HOISTED */);

function render$1y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1y, [
    _hoisted_2$1y
  ]))
}

script$1y.render = render$1y;
script$1y.__file = "lib/components/Icons/Outline/ODotsHorizontal.vue";

var script$1z = defineComponent({
  name: 'OCash'
});

const _hoisted_1$1z = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1z = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
}, null, -1 /* HOISTED */);

function render$1z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1z, [
    _hoisted_2$1z
  ]))
}

script$1z.render = render$1z;
script$1z.__file = "lib/components/Icons/Outline/OCash.vue";

var script$1A = defineComponent({
  name: 'OChevronRight'
});

const _hoisted_1$1A = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1A = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 5l7 7-7 7"
}, null, -1 /* HOISTED */);

function render$1A(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1A, [
    _hoisted_2$1A
  ]))
}

script$1A.render = render$1A;
script$1A.__file = "lib/components/Icons/Outline/OChevronRight.vue";

var script$1B = defineComponent({
  name: 'OStatusOnline'
});

const _hoisted_1$1B = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1B = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
}, null, -1 /* HOISTED */);

function render$1B(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1B, [
    _hoisted_2$1B
  ]))
}

script$1B.render = render$1B;
script$1B.__file = "lib/components/Icons/Outline/OStatusOnline.vue";

var script$1C = defineComponent({
  name: 'OSelector'
});

const _hoisted_1$1C = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1C = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 9l4-4 4 4m0 6l-4 4-4-4"
}, null, -1 /* HOISTED */);

function render$1C(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1C, [
    _hoisted_2$1C
  ]))
}

script$1C.render = render$1C;
script$1C.__file = "lib/components/Icons/Outline/OSelector.vue";

var script$1D = defineComponent({
  name: 'ODocument'
});

const _hoisted_1$1D = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1D = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$1D(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1D, [
    _hoisted_2$1D
  ]))
}

script$1D.render = render$1D;
script$1D.__file = "lib/components/Icons/Outline/ODocument.vue";

var script$1E = defineComponent({
  name: 'OTrash'
});

const _hoisted_1$1E = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1E = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
}, null, -1 /* HOISTED */);

function render$1E(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1E, [
    _hoisted_2$1E
  ]))
}

script$1E.render = render$1E;
script$1E.__file = "lib/components/Icons/Outline/OTrash.vue";

var script$1F = defineComponent({
  name: 'ODocumentText'
});

const _hoisted_1$1F = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1F = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
}, null, -1 /* HOISTED */);

function render$1F(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1F, [
    _hoisted_2$1F
  ]))
}

script$1F.render = render$1F;
script$1F.__file = "lib/components/Icons/Outline/ODocumentText.vue";

var script$1G = defineComponent({
  name: 'OCurrencyPound'
});

const _hoisted_1$1G = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1G = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$1G(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1G, [
    _hoisted_2$1G
  ]))
}

script$1G.render = render$1G;
script$1G.__file = "lib/components/Icons/Outline/OCurrencyPound.vue";

var script$1H = defineComponent({
  name: 'OPresentationChartBar'
});

const _hoisted_1$1H = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1H = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
}, null, -1 /* HOISTED */);

function render$1H(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1H, [
    _hoisted_2$1H
  ]))
}

script$1H.render = render$1H;
script$1H.__file = "lib/components/Icons/Outline/OPresentationChartBar.vue";

var script$1I = defineComponent({
  name: 'OChatAlt2'
});

const _hoisted_1$1I = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1I = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
}, null, -1 /* HOISTED */);

function render$1I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1I, [
    _hoisted_2$1I
  ]))
}

script$1I.render = render$1I;
script$1I.__file = "lib/components/Icons/Outline/OChatAlt2.vue";

var script$1J = defineComponent({
  name: 'OPhone'
});

const _hoisted_1$1J = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1J = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
}, null, -1 /* HOISTED */);

function render$1J(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1J, [
    _hoisted_2$1J
  ]))
}

script$1J.render = render$1J;
script$1J.__file = "lib/components/Icons/Outline/OPhone.vue";

var script$1K = defineComponent({
  name: 'OClipboardCheck'
});

const _hoisted_1$1K = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1K = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
}, null, -1 /* HOISTED */);

function render$1K(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1K, [
    _hoisted_2$1K
  ]))
}

script$1K.render = render$1K;
script$1K.__file = "lib/components/Icons/Outline/OClipboardCheck.vue";

var script$1L = defineComponent({
  name: 'ODeviceMobile'
});

const _hoisted_1$1L = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1L = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$1L(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1L, [
    _hoisted_2$1L
  ]))
}

script$1L.render = render$1L;
script$1L.__file = "lib/components/Icons/Outline/ODeviceMobile.vue";

var script$1M = defineComponent({
  name: 'OHome'
});

const _hoisted_1$1M = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1M = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
}, null, -1 /* HOISTED */);

function render$1M(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1M, [
    _hoisted_2$1M
  ]))
}

script$1M.render = render$1M;
script$1M.__file = "lib/components/Icons/Outline/OHome.vue";

var script$1N = defineComponent({
  name: 'OLibrary'
});

const _hoisted_1$1N = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1N = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
}, null, -1 /* HOISTED */);

function render$1N(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1N, [
    _hoisted_2$1N
  ]))
}

script$1N.render = render$1N;
script$1N.__file = "lib/components/Icons/Outline/OLibrary.vue";

var script$1O = defineComponent({
  name: 'OFolderRemove'
});

const _hoisted_1$1O = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1O = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
}, null, -1 /* HOISTED */);

function render$1O(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1O, [
    _hoisted_2$1O
  ]))
}

script$1O.render = render$1O;
script$1O.__file = "lib/components/Icons/Outline/OFolderRemove.vue";

var script$1P = defineComponent({
  name: 'OArrowCircleUp'
});

const _hoisted_1$1P = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1P = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
}, null, -1 /* HOISTED */);

function render$1P(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1P, [
    _hoisted_2$1P
  ]))
}

script$1P.render = render$1P;
script$1P.__file = "lib/components/Icons/Outline/OArrowCircleUp.vue";

var script$1Q = defineComponent({
  name: 'OSortAscending'
});

const _hoisted_1$1Q = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1Q = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
}, null, -1 /* HOISTED */);

function render$1Q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1Q, [
    _hoisted_2$1Q
  ]))
}

script$1Q.render = render$1Q;
script$1Q.__file = "lib/components/Icons/Outline/OSortAscending.vue";

var script$1R = defineComponent({
  name: 'OMinusCircle'
});

const _hoisted_1$1R = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1R = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$1R(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1R, [
    _hoisted_2$1R
  ]))
}

script$1R.render = render$1R;
script$1R.__file = "lib/components/Icons/Outline/OMinusCircle.vue";

var script$1S = defineComponent({
  name: 'OViewGridAdd'
});

const _hoisted_1$1S = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1S = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$1S(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1S, [
    _hoisted_2$1S
  ]))
}

script$1S.render = render$1S;
script$1S.__file = "lib/components/Icons/Outline/OViewGridAdd.vue";

var script$1T = defineComponent({
  name: 'OArrowsExpand'
});

const _hoisted_1$1T = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1T = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
}, null, -1 /* HOISTED */);

function render$1T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1T, [
    _hoisted_2$1T
  ]))
}

script$1T.render = render$1T;
script$1T.__file = "lib/components/Icons/Outline/OArrowsExpand.vue";

var script$1U = defineComponent({
  name: 'OChevronLeft'
});

const _hoisted_1$1U = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1U = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 19l-7-7 7-7"
}, null, -1 /* HOISTED */);

function render$1U(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1U, [
    _hoisted_2$1U
  ]))
}

script$1U.render = render$1U;
script$1U.__file = "lib/components/Icons/Outline/OChevronLeft.vue";

var script$1V = defineComponent({
  name: 'OTable'
});

const _hoisted_1$1V = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1V = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$1V(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1V, [
    _hoisted_2$1V
  ]))
}

script$1V.render = render$1V;
script$1V.__file = "lib/components/Icons/Outline/OTable.vue";

var script$1W = defineComponent({
  name: 'OBan'
});

const _hoisted_1$1W = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1W = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
}, null, -1 /* HOISTED */);

function render$1W(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1W, [
    _hoisted_2$1W
  ]))
}

script$1W.render = render$1W;
script$1W.__file = "lib/components/Icons/Outline/OBan.vue";

var script$1X = defineComponent({
  name: 'ODuplicate'
});

const _hoisted_1$1X = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1X = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$1X(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1X, [
    _hoisted_2$1X
  ]))
}

script$1X.render = render$1X;
script$1X.__file = "lib/components/Icons/Outline/ODuplicate.vue";

var script$1Y = defineComponent({
  name: 'OPaperClip'
});

const _hoisted_1$1Y = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1Y = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
}, null, -1 /* HOISTED */);

function render$1Y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1Y, [
    _hoisted_2$1Y
  ]))
}

script$1Y.render = render$1Y;
script$1Y.__file = "lib/components/Icons/Outline/OPaperClip.vue";

var script$1Z = defineComponent({
  name: 'OPuzzle'
});

const _hoisted_1$1Z = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1Z = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"
}, null, -1 /* HOISTED */);

function render$1Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1Z, [
    _hoisted_2$1Z
  ]))
}

script$1Z.render = render$1Z;
script$1Z.__file = "lib/components/Icons/Outline/OPuzzle.vue";

var script$1_ = defineComponent({
  name: 'OExternalLink'
});

const _hoisted_1$1_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1_ = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
}, null, -1 /* HOISTED */);

function render$1_(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1_, [
    _hoisted_2$1_
  ]))
}

script$1_.render = render$1_;
script$1_.__file = "lib/components/Icons/Outline/OExternalLink.vue";

var script$1$ = defineComponent({
  name: 'OVolumeOff'
});

const _hoisted_1$1$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$1$ = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$7 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
}, null, -1 /* HOISTED */);

function render$1$(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$1$, [
    _hoisted_2$1$,
    _hoisted_3$7
  ]))
}

script$1$.render = render$1$;
script$1$.__file = "lib/components/Icons/Outline/OVolumeOff.vue";

var script$20 = defineComponent({
  name: 'OPaperAirplane'
});

const _hoisted_1$20 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$20 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
}, null, -1 /* HOISTED */);

function render$20(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$20, [
    _hoisted_2$20
  ]))
}

script$20.render = render$20;
script$20.__file = "lib/components/Icons/Outline/OPaperAirplane.vue";

var script$21 = defineComponent({
  name: 'OShoppingCart'
});

const _hoisted_1$21 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$21 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
}, null, -1 /* HOISTED */);

function render$21(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$21, [
    _hoisted_2$21
  ]))
}

script$21.render = render$21;
script$21.__file = "lib/components/Icons/Outline/OShoppingCart.vue";

var script$22 = defineComponent({
  name: 'OChartBar'
});

const _hoisted_1$22 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$22 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
}, null, -1 /* HOISTED */);

function render$22(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$22, [
    _hoisted_2$22
  ]))
}

script$22.render = render$22;
script$22.__file = "lib/components/Icons/Outline/OChartBar.vue";

var script$23 = defineComponent({
  name: 'OStar'
});

const _hoisted_1$23 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$23 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
}, null, -1 /* HOISTED */);

function render$23(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$23, [
    _hoisted_2$23
  ]))
}

script$23.render = render$23;
script$23.__file = "lib/components/Icons/Outline/OStar.vue";

var script$24 = defineComponent({
  name: 'ODocumentDuplicate'
});

const _hoisted_1$24 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$24 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
}, null, -1 /* HOISTED */);

function render$24(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$24, [
    _hoisted_2$24
  ]))
}

script$24.render = render$24;
script$24.__file = "lib/components/Icons/Outline/ODocumentDuplicate.vue";

var script$25 = defineComponent({
  name: 'OUserGroup'
});

const _hoisted_1$25 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$25 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
}, null, -1 /* HOISTED */);

function render$25(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$25, [
    _hoisted_2$25
  ]))
}

script$25.render = render$25;
script$25.__file = "lib/components/Icons/Outline/OUserGroup.vue";

var script$26 = defineComponent({
  name: 'OChevronDown'
});

const _hoisted_1$26 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$26 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1 /* HOISTED */);

function render$26(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$26, [
    _hoisted_2$26
  ]))
}

script$26.render = render$26;
script$26.__file = "lib/components/Icons/Outline/OChevronDown.vue";

var script$27 = defineComponent({
  name: 'OChartPie'
});

const _hoisted_1$27 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$27 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
}, null, -1 /* HOISTED */);
const _hoisted_3$8 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
}, null, -1 /* HOISTED */);

function render$27(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$27, [
    _hoisted_2$27,
    _hoisted_3$8
  ]))
}

script$27.render = render$27;
script$27.__file = "lib/components/Icons/Outline/OChartPie.vue";

var script$28 = defineComponent({
  name: 'OUsers'
});

const _hoisted_1$28 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$28 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
}, null, -1 /* HOISTED */);

function render$28(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$28, [
    _hoisted_2$28
  ]))
}

script$28.render = render$28;
script$28.__file = "lib/components/Icons/Outline/OUsers.vue";

var script$29 = defineComponent({
  name: 'OCubeTransparent'
});

const _hoisted_1$29 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$29 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
}, null, -1 /* HOISTED */);

function render$29(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$29, [
    _hoisted_2$29
  ]))
}

script$29.render = render$29;
script$29.__file = "lib/components/Icons/Outline/OCubeTransparent.vue";

var script$2a = defineComponent({
  name: 'OShoppingBag'
});

const _hoisted_1$2a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2a = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
}, null, -1 /* HOISTED */);

function render$2a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2a, [
    _hoisted_2$2a
  ]))
}

script$2a.render = render$2a;
script$2a.__file = "lib/components/Icons/Outline/OShoppingBag.vue";

var script$2b = defineComponent({
  name: 'OBeaker'
});

const _hoisted_1$2b = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2b = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
}, null, -1 /* HOISTED */);

function render$2b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2b, [
    _hoisted_2$2b
  ]))
}

script$2b.render = render$2b;
script$2b.__file = "lib/components/Icons/Outline/OBeaker.vue";

var script$2c = defineComponent({
  name: 'OCheckCircle'
});

const _hoisted_1$2c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2c = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$2c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2c, [
    _hoisted_2$2c
  ]))
}

script$2c.render = render$2c;
script$2c.__file = "lib/components/Icons/Outline/OCheckCircle.vue";

var script$2d = defineComponent({
  name: 'OPhoneOutgoing'
});

const _hoisted_1$2d = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2d = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
}, null, -1 /* HOISTED */);

function render$2d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2d, [
    _hoisted_2$2d
  ]))
}

script$2d.render = render$2d;
script$2d.__file = "lib/components/Icons/Outline/OPhoneOutgoing.vue";

var script$2e = defineComponent({
  name: 'OTranslate'
});

const _hoisted_1$2e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2e = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
}, null, -1 /* HOISTED */);

function render$2e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2e, [
    _hoisted_2$2e
  ]))
}

script$2e.render = render$2e;
script$2e.__file = "lib/components/Icons/Outline/OTranslate.vue";

var script$2f = defineComponent({
  name: 'OPencilAlt'
});

const _hoisted_1$2f = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2f = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
}, null, -1 /* HOISTED */);

function render$2f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2f, [
    _hoisted_2$2f
  ]))
}

script$2f.render = render$2f;
script$2f.__file = "lib/components/Icons/Outline/OPencilAlt.vue";

var script$2g = defineComponent({
  name: 'OArrowRight'
});

const _hoisted_1$2g = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2g = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14 5l7 7m0 0l-7 7m7-7H3"
}, null, -1 /* HOISTED */);

function render$2g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2g, [
    _hoisted_2$2g
  ]))
}

script$2g.render = render$2g;
script$2g.__file = "lib/components/Icons/Outline/OArrowRight.vue";

var script$2h = defineComponent({
  name: 'OSun'
});

const _hoisted_1$2h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2h = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
}, null, -1 /* HOISTED */);

function render$2h(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2h, [
    _hoisted_2$2h
  ]))
}

script$2h.render = render$2h;
script$2h.__file = "lib/components/Icons/Outline/OSun.vue";

var script$2i = defineComponent({
  name: 'OLogin'
});

const _hoisted_1$2i = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2i = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
}, null, -1 /* HOISTED */);

function render$2i(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2i, [
    _hoisted_2$2i
  ]))
}

script$2i.render = render$2i;
script$2i.__file = "lib/components/Icons/Outline/OLogin.vue";

var script$2j = defineComponent({
  name: 'OZoomIn'
});

const _hoisted_1$2j = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2j = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
}, null, -1 /* HOISTED */);

function render$2j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2j, [
    _hoisted_2$2j
  ]))
}

script$2j.render = render$2j;
script$2j.__file = "lib/components/Icons/Outline/OZoomIn.vue";

var script$2k = defineComponent({
  name: 'OUpload'
});

const _hoisted_1$2k = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2k = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
}, null, -1 /* HOISTED */);

function render$2k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2k, [
    _hoisted_2$2k
  ]))
}

script$2k.render = render$2k;
script$2k.__file = "lib/components/Icons/Outline/OUpload.vue";

var script$2l = defineComponent({
  name: 'OScissors'
});

const _hoisted_1$2l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2l = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z"
}, null, -1 /* HOISTED */);

function render$2l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2l, [
    _hoisted_2$2l
  ]))
}

script$2l.render = render$2l;
script$2l.__file = "lib/components/Icons/Outline/OScissors.vue";

var script$2m = defineComponent({
  name: 'OChevronDoubleLeft'
});

const _hoisted_1$2m = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2m = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
}, null, -1 /* HOISTED */);

function render$2m(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2m, [
    _hoisted_2$2m
  ]))
}

script$2m.render = render$2m;
script$2m.__file = "lib/components/Icons/Outline/OChevronDoubleLeft.vue";

var script$2n = defineComponent({
  name: 'OChevronDoubleRight'
});

const _hoisted_1$2n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2n = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 5l7 7-7 7M5 5l7 7-7 7"
}, null, -1 /* HOISTED */);

function render$2n(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2n, [
    _hoisted_2$2n
  ]))
}

script$2n.render = render$2n;
script$2n.__file = "lib/components/Icons/Outline/OChevronDoubleRight.vue";

var script$2o = defineComponent({
  name: 'OGlobeAlt'
});

const _hoisted_1$2o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2o = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
}, null, -1 /* HOISTED */);

function render$2o(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2o, [
    _hoisted_2$2o
  ]))
}

script$2o.render = render$2o;
script$2o.__file = "lib/components/Icons/Outline/OGlobeAlt.vue";

var script$2p = defineComponent({
  name: 'OLockClosed'
});

const _hoisted_1$2p = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2p = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
}, null, -1 /* HOISTED */);

function render$2p(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2p, [
    _hoisted_2$2p
  ]))
}

script$2p.render = render$2p;
script$2p.__file = "lib/components/Icons/Outline/OLockClosed.vue";

var script$2q = defineComponent({
  name: 'OSupport'
});

const _hoisted_1$2q = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2q = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
}, null, -1 /* HOISTED */);

function render$2q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2q, [
    _hoisted_2$2q
  ]))
}

script$2q.render = render$2q;
script$2q.__file = "lib/components/Icons/Outline/OSupport.vue";

var script$2r = defineComponent({
  name: 'OShieldCheck'
});

const _hoisted_1$2r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2r = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
}, null, -1 /* HOISTED */);

function render$2r(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2r, [
    _hoisted_2$2r
  ]))
}

script$2r.render = render$2r;
script$2r.__file = "lib/components/Icons/Outline/OShieldCheck.vue";

var script$2s = defineComponent({
  name: 'OCloudDownload'
});

const _hoisted_1$2s = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2s = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
}, null, -1 /* HOISTED */);

function render$2s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2s, [
    _hoisted_2$2s
  ]))
}

script$2s.render = render$2s;
script$2s.__file = "lib/components/Icons/Outline/OCloudDownload.vue";

var script$2t = defineComponent({
  name: 'OShieldExclamation'
});

const _hoisted_1$2t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2t = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"
}, null, -1 /* HOISTED */);

function render$2t(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2t, [
    _hoisted_2$2t
  ]))
}

script$2t.render = render$2t;
script$2t.__file = "lib/components/Icons/Outline/OShieldExclamation.vue";

var script$2u = defineComponent({
  name: 'OIdentification'
});

const _hoisted_1$2u = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2u = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
}, null, -1 /* HOISTED */);

function render$2u(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2u, [
    _hoisted_2$2u
  ]))
}

script$2u.render = render$2u;
script$2u.__file = "lib/components/Icons/Outline/OIdentification.vue";

var script$2v = defineComponent({
  name: 'OClipboardList'
});

const _hoisted_1$2v = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2v = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
}, null, -1 /* HOISTED */);

function render$2v(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2v, [
    _hoisted_2$2v
  ]))
}

script$2v.render = render$2v;
script$2v.__file = "lib/components/Icons/Outline/OClipboardList.vue";

var script$2w = defineComponent({
  name: 'OCloud'
});

const _hoisted_1$2w = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2w = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
}, null, -1 /* HOISTED */);

function render$2w(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2w, [
    _hoisted_2$2w
  ]))
}

script$2w.render = render$2w;
script$2w.__file = "lib/components/Icons/Outline/OCloud.vue";

var script$2x = defineComponent({
  name: 'OSparkles'
});

const _hoisted_1$2x = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2x = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
}, null, -1 /* HOISTED */);

function render$2x(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2x, [
    _hoisted_2$2x
  ]))
}

script$2x.render = render$2x;
script$2x.__file = "lib/components/Icons/Outline/OSparkles.vue";

var script$2y = defineComponent({
  name: 'OExclamationCircle'
});

const _hoisted_1$2y = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2y = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$2y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2y, [
    _hoisted_2$2y
  ]))
}

script$2y.render = render$2y;
script$2y.__file = "lib/components/Icons/Outline/OExclamationCircle.vue";

var script$2z = defineComponent({
  name: 'OBadgeCheck'
});

const _hoisted_1$2z = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2z = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
}, null, -1 /* HOISTED */);

function render$2z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2z, [
    _hoisted_2$2z
  ]))
}

script$2z.render = render$2z;
script$2z.__file = "lib/components/Icons/Outline/OBadgeCheck.vue";

var script$2A = defineComponent({
  name: 'OFastForward'
});

const _hoisted_1$2A = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2A = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"
}, null, -1 /* HOISTED */);

function render$2A(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2A, [
    _hoisted_2$2A
  ]))
}

script$2A.render = render$2A;
script$2A.__file = "lib/components/Icons/Outline/OFastForward.vue";

var script$2B = defineComponent({
  name: 'OFire'
});

const _hoisted_1$2B = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2B = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
}, null, -1 /* HOISTED */);
const _hoisted_3$9 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
}, null, -1 /* HOISTED */);

function render$2B(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2B, [
    _hoisted_2$2B,
    _hoisted_3$9
  ]))
}

script$2B.render = render$2B;
script$2B.__file = "lib/components/Icons/Outline/OFire.vue";

var script$2C = defineComponent({
  name: 'OClipboard'
});

const _hoisted_1$2C = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2C = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
}, null, -1 /* HOISTED */);

function render$2C(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2C, [
    _hoisted_2$2C
  ]))
}

script$2C.render = render$2C;
script$2C.__file = "lib/components/Icons/Outline/OClipboard.vue";

var script$2D = defineComponent({
  name: 'OBookOpen'
});

const _hoisted_1$2D = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2D = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
}, null, -1 /* HOISTED */);

function render$2D(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2D, [
    _hoisted_2$2D
  ]))
}

script$2D.render = render$2D;
script$2D.__file = "lib/components/Icons/Outline/OBookOpen.vue";

var script$2E = defineComponent({
  name: 'ODocumentAdd'
});

const _hoisted_1$2E = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2E = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
}, null, -1 /* HOISTED */);

function render$2E(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2E, [
    _hoisted_2$2E
  ]))
}

script$2E.render = render$2E;
script$2E.__file = "lib/components/Icons/Outline/ODocumentAdd.vue";

var script$2F = defineComponent({
  name: 'OMenuAlt3'
});

const _hoisted_1$2F = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2F = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16m-7 6h7"
}, null, -1 /* HOISTED */);

function render$2F(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2F, [
    _hoisted_2$2F
  ]))
}

script$2F.render = render$2F;
script$2F.__file = "lib/components/Icons/Outline/OMenuAlt3.vue";

var script$2G = defineComponent({
  name: 'OLightBulb'
});

const _hoisted_1$2G = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2G = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
}, null, -1 /* HOISTED */);

function render$2G(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2G, [
    _hoisted_2$2G
  ]))
}

script$2G.render = render$2G;
script$2G.__file = "lib/components/Icons/Outline/OLightBulb.vue";

var script$2H = defineComponent({
  name: 'ORefresh'
});

const _hoisted_1$2H = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2H = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
}, null, -1 /* HOISTED */);

function render$2H(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2H, [
    _hoisted_2$2H
  ]))
}

script$2H.render = render$2H;
script$2H.__file = "lib/components/Icons/Outline/ORefresh.vue";

var script$2I = defineComponent({
  name: 'OAnnotation'
});

const _hoisted_1$2I = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2I = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
}, null, -1 /* HOISTED */);

function render$2I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2I, [
    _hoisted_2$2I
  ]))
}

script$2I.render = render$2I;
script$2I.__file = "lib/components/Icons/Outline/OAnnotation.vue";

var script$2J = defineComponent({
  name: 'OFolderOpen'
});

const _hoisted_1$2J = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2J = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
}, null, -1 /* HOISTED */);

function render$2J(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2J, [
    _hoisted_2$2J
  ]))
}

script$2J.render = render$2J;
script$2J.__file = "lib/components/Icons/Outline/OFolderOpen.vue";

var script$2K = defineComponent({
  name: 'ODotsCircleHorizontal'
});

const _hoisted_1$2K = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2K = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$2K(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2K, [
    _hoisted_2$2K
  ]))
}

script$2K.render = render$2K;
script$2K.__file = "lib/components/Icons/Outline/ODotsCircleHorizontal.vue";

var script$2L = defineComponent({
  name: 'OTerminal'
});

const _hoisted_1$2L = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2L = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$2L(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2L, [
    _hoisted_2$2L
  ]))
}

script$2L.render = render$2L;
script$2L.__file = "lib/components/Icons/Outline/OTerminal.vue";

var script$2M = defineComponent({
  name: 'OUser'
});

const _hoisted_1$2M = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2M = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
}, null, -1 /* HOISTED */);

function render$2M(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2M, [
    _hoisted_2$2M
  ]))
}

script$2M.render = render$2M;
script$2M.__file = "lib/components/Icons/Outline/OUser.vue";

var script$2N = defineComponent({
  name: 'OPhoneIncoming'
});

const _hoisted_1$2N = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2N = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
}, null, -1 /* HOISTED */);

function render$2N(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2N, [
    _hoisted_2$2N
  ]))
}

script$2N.render = render$2N;
script$2N.__file = "lib/components/Icons/Outline/OPhoneIncoming.vue";

var script$2O = defineComponent({
  name: 'OUserRemove'
});

const _hoisted_1$2O = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2O = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"
}, null, -1 /* HOISTED */);

function render$2O(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2O, [
    _hoisted_2$2O
  ]))
}

script$2O.render = render$2O;
script$2O.__file = "lib/components/Icons/Outline/OUserRemove.vue";

var script$2P = defineComponent({
  name: 'OBookmark'
});

const _hoisted_1$2P = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2P = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
}, null, -1 /* HOISTED */);

function render$2P(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2P, [
    _hoisted_2$2P
  ]))
}

script$2P.render = render$2P;
script$2P.__file = "lib/components/Icons/Outline/OBookmark.vue";

var script$2Q = defineComponent({
  name: 'OX'
});

const _hoisted_1$2Q = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2Q = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1 /* HOISTED */);

function render$2Q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2Q, [
    _hoisted_2$2Q
  ]))
}

script$2Q.render = render$2Q;
script$2Q.__file = "lib/components/Icons/Outline/OX.vue";

var script$2R = defineComponent({
  name: 'OCog'
});

const _hoisted_1$2R = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2R = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
}, null, -1 /* HOISTED */);
const _hoisted_3$a = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
}, null, -1 /* HOISTED */);

function render$2R(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2R, [
    _hoisted_2$2R,
    _hoisted_3$a
  ]))
}

script$2R.render = render$2R;
script$2R.__file = "lib/components/Icons/Outline/OCog.vue";

var script$2S = defineComponent({
  name: 'OThumbUp'
});

const _hoisted_1$2S = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2S = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
}, null, -1 /* HOISTED */);

function render$2S(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2S, [
    _hoisted_2$2S
  ]))
}

script$2S.render = render$2S;
script$2S.__file = "lib/components/Icons/Outline/OThumbUp.vue";

var script$2T = defineComponent({
  name: 'OCurrencyBangladeshi'
});

const _hoisted_1$2T = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2T = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 11V9a2 2 0 00-2-2m2 4v4a2 2 0 104 0v-1m-4-3H9m2 0h4m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$2T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2T, [
    _hoisted_2$2T
  ]))
}

script$2T.render = render$2T;
script$2T.__file = "lib/components/Icons/Outline/OCurrencyBangladeshi.vue";

var script$2U = defineComponent({
  name: 'OVariable'
});

const _hoisted_1$2U = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2U = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4.871 4A17.926 17.926 0 003 12c0 2.874.673 5.59 1.871 8m14.13 0a17.926 17.926 0 001.87-8c0-2.874-.673-5.59-1.87-8M9 9h1.246a1 1 0 01.961.725l1.586 5.55a1 1 0 00.961.725H15m1-7h-.08a2 2 0 00-1.519.698L9.6 15.302A2 2 0 018.08 16H8"
}, null, -1 /* HOISTED */);

function render$2U(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2U, [
    _hoisted_2$2U
  ]))
}

script$2U.render = render$2U;
script$2U.__file = "lib/components/Icons/Outline/OVariable.vue";

var script$2V = defineComponent({
  name: 'OUserCircle'
});

const _hoisted_1$2V = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2V = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$2V(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2V, [
    _hoisted_2$2V
  ]))
}

script$2V.render = render$2V;
script$2V.__file = "lib/components/Icons/Outline/OUserCircle.vue";

var script$2W = defineComponent({
  name: 'OArrowNarrowLeft'
});

const _hoisted_1$2W = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2W = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 16l-4-4m0 0l4-4m-4 4h18"
}, null, -1 /* HOISTED */);

function render$2W(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2W, [
    _hoisted_2$2W
  ]))
}

script$2W.render = render$2W;
script$2W.__file = "lib/components/Icons/Outline/OArrowNarrowLeft.vue";

var script$2X = defineComponent({
  name: 'OShare'
});

const _hoisted_1$2X = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2X = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
}, null, -1 /* HOISTED */);

function render$2X(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2X, [
    _hoisted_2$2X
  ]))
}

script$2X.render = render$2X;
script$2X.__file = "lib/components/Icons/Outline/OShare.vue";

var script$2Y = defineComponent({
  name: 'OFolder'
});

const _hoisted_1$2Y = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2Y = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
}, null, -1 /* HOISTED */);

function render$2Y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2Y, [
    _hoisted_2$2Y
  ]))
}

script$2Y.render = render$2Y;
script$2Y.__file = "lib/components/Icons/Outline/OFolder.vue";

var script$2Z = defineComponent({
  name: 'OArrowNarrowRight'
});

const _hoisted_1$2Z = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2Z = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 8l4 4m0 0l-4 4m4-4H3"
}, null, -1 /* HOISTED */);

function render$2Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2Z, [
    _hoisted_2$2Z
  ]))
}

script$2Z.render = render$2Z;
script$2Z.__file = "lib/components/Icons/Outline/OArrowNarrowRight.vue";

var script$2_ = defineComponent({
  name: 'ODownload'
});

const _hoisted_1$2_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2_ = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
}, null, -1 /* HOISTED */);

function render$2_(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2_, [
    _hoisted_2$2_
  ]))
}

script$2_.render = render$2_;
script$2_.__file = "lib/components/Icons/Outline/ODownload.vue";

var script$2$ = defineComponent({
  name: 'OHand'
});

const _hoisted_1$2$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$2$ = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
}, null, -1 /* HOISTED */);

function render$2$(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$2$, [
    _hoisted_2$2$
  ]))
}

script$2$.render = render$2$;
script$2$.__file = "lib/components/Icons/Outline/OHand.vue";

var script$30 = defineComponent({
  name: 'OMenu'
});

const _hoisted_1$30 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$30 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16"
}, null, -1 /* HOISTED */);

function render$30(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$30, [
    _hoisted_2$30
  ]))
}

script$30.render = render$30;
script$30.__file = "lib/components/Icons/Outline/OMenu.vue";

var script$31 = defineComponent({
  name: 'OBackspace'
});

const _hoisted_1$31 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$31 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"
}, null, -1 /* HOISTED */);

function render$31(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$31, [
    _hoisted_2$31
  ]))
}

script$31.render = render$31;
script$31.__file = "lib/components/Icons/Outline/OBackspace.vue";

var script$32 = defineComponent({
  name: 'OVolumeUp'
});

const _hoisted_1$32 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$32 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
}, null, -1 /* HOISTED */);

function render$32(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$32, [
    _hoisted_2$32
  ]))
}

script$32.render = render$32;
script$32.__file = "lib/components/Icons/Outline/OVolumeUp.vue";

var script$33 = defineComponent({
  name: 'OInboxIn'
});

const _hoisted_1$33 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$33 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
}, null, -1 /* HOISTED */);

function render$33(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$33, [
    _hoisted_2$33
  ]))
}

script$33.render = render$33;
script$33.__file = "lib/components/Icons/Outline/OInboxIn.vue";

var script$34 = defineComponent({
  name: 'OInbox'
});

const _hoisted_1$34 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$34 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
}, null, -1 /* HOISTED */);

function render$34(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$34, [
    _hoisted_2$34
  ]))
}

script$34.render = render$34;
script$34.__file = "lib/components/Icons/Outline/OInbox.vue";

var script$35 = defineComponent({
  name: 'OEmojiSad'
});

const _hoisted_1$35 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$35 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$35(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$35, [
    _hoisted_2$35
  ]))
}

script$35.render = render$35;
script$35.__file = "lib/components/Icons/Outline/OEmojiSad.vue";

var script$36 = defineComponent({
  name: 'OExclamation'
});

const _hoisted_1$36 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$36 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
}, null, -1 /* HOISTED */);

function render$36(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$36, [
    _hoisted_2$36
  ]))
}

script$36.render = render$36;
script$36.__file = "lib/components/Icons/Outline/OExclamation.vue";

var script$37 = defineComponent({
  name: 'OChat'
});

const _hoisted_1$37 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$37 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
}, null, -1 /* HOISTED */);

function render$37(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$37, [
    _hoisted_2$37
  ]))
}

script$37.render = render$37;
script$37.__file = "lib/components/Icons/Outline/OChat.vue";

var script$38 = defineComponent({
  name: 'OBookmarkAlt'
});

const _hoisted_1$38 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$38 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
}, null, -1 /* HOISTED */);

function render$38(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$38, [
    _hoisted_2$38
  ]))
}

script$38.render = render$38;
script$38.__file = "lib/components/Icons/Outline/OBookmarkAlt.vue";

var script$39 = defineComponent({
  name: 'OCake'
});

const _hoisted_1$39 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$39 = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z"
}, null, -1 /* HOISTED */);

function render$39(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$39, [
    _hoisted_2$39
  ]))
}

script$39.render = render$39;
script$39.__file = "lib/components/Icons/Outline/OCake.vue";

var script$3a = defineComponent({
  name: 'OChevronUp'
});

const _hoisted_1$3a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3a = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 15l7-7 7 7"
}, null, -1 /* HOISTED */);

function render$3a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3a, [
    _hoisted_2$3a
  ]))
}

script$3a.render = render$3a;
script$3a.__file = "lib/components/Icons/Outline/OChevronUp.vue";

var script$3b = defineComponent({
  name: 'OQuestionMarkCircle'
});

const _hoisted_1$3b = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3b = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$3b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3b, [
    _hoisted_2$3b
  ]))
}

script$3b.render = render$3b;
script$3b.__file = "lib/components/Icons/Outline/OQuestionMarkCircle.vue";

var script$3c = defineComponent({
  name: 'OMinusSm'
});

const _hoisted_1$3c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3c = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M18 12H6"
}, null, -1 /* HOISTED */);

function render$3c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3c, [
    _hoisted_2$3c
  ]))
}

script$3c.render = render$3c;
script$3c.__file = "lib/components/Icons/Outline/OMinusSm.vue";

var script$3d = defineComponent({
  name: 'OThumbDown'
});

const _hoisted_1$3d = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3d = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
}, null, -1 /* HOISTED */);

function render$3d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3d, [
    _hoisted_2$3d
  ]))
}

script$3d.render = render$3d;
script$3d.__file = "lib/components/Icons/Outline/OThumbDown.vue";

var script$3e = defineComponent({
  name: 'OZoomOut'
});

const _hoisted_1$3e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3e = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"
}, null, -1 /* HOISTED */);

function render$3e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3e, [
    _hoisted_2$3e
  ]))
}

script$3e.render = render$3e;
script$3e.__file = "lib/components/Icons/Outline/OZoomOut.vue";

var script$3f = defineComponent({
  name: 'OArrowLeft'
});

const _hoisted_1$3f = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3f = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 19l-7-7m0 0l7-7m-7 7h18"
}, null, -1 /* HOISTED */);

function render$3f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3f, [
    _hoisted_2$3f
  ]))
}

script$3f.render = render$3f;
script$3f.__file = "lib/components/Icons/Outline/OArrowLeft.vue";

var script$3g = defineComponent({
  name: 'OCursorClick'
});

const _hoisted_1$3g = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3g = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
}, null, -1 /* HOISTED */);

function render$3g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3g, [
    _hoisted_2$3g
  ]))
}

script$3g.render = render$3g;
script$3g.__file = "lib/components/Icons/Outline/OCursorClick.vue";

var script$3h = defineComponent({
  name: 'ODocumentRemove'
});

const _hoisted_1$3h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3h = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
}, null, -1 /* HOISTED */);

function render$3h(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3h, [
    _hoisted_2$3h
  ]))
}

script$3h.render = render$3h;
script$3h.__file = "lib/components/Icons/Outline/ODocumentRemove.vue";

var script$3i = defineComponent({
  name: 'OTrendingDown'
});

const _hoisted_1$3i = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3i = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
}, null, -1 /* HOISTED */);

function render$3i(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3i, [
    _hoisted_2$3i
  ]))
}

script$3i.render = render$3i;
script$3i.__file = "lib/components/Icons/Outline/OTrendingDown.vue";

var script$3j = defineComponent({
  name: 'OSaveAs'
});

const _hoisted_1$3j = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3j = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M17 16v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h2m3-4H9a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1m-1 4l-3 3m0 0l-3-3m3 3V3"
}, null, -1 /* HOISTED */);

function render$3j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3j, [
    _hoisted_2$3j
  ]))
}

script$3j.render = render$3j;
script$3j.__file = "lib/components/Icons/Outline/OSaveAs.vue";

var script$3k = defineComponent({
  name: 'OClipboardCopy'
});

const _hoisted_1$3k = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3k = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
}, null, -1 /* HOISTED */);

function render$3k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3k, [
    _hoisted_2$3k
  ]))
}

script$3k.render = render$3k;
script$3k.__file = "lib/components/Icons/Outline/OClipboardCopy.vue";

var script$3l = defineComponent({
  name: 'ODotsVertical'
});

const _hoisted_1$3l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3l = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
}, null, -1 /* HOISTED */);

function render$3l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3l, [
    _hoisted_2$3l
  ]))
}

script$3l.render = render$3l;
script$3l.__file = "lib/components/Icons/Outline/ODotsVertical.vue";

var script$3m = defineComponent({
  name: 'OBell'
});

const _hoisted_1$3m = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3m = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
}, null, -1 /* HOISTED */);

function render$3m(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3m, [
    _hoisted_2$3m
  ]))
}

script$3m.render = render$3m;
script$3m.__file = "lib/components/Icons/Outline/OBell.vue";

var script$3n = defineComponent({
  name: 'OXCircle'
});

const _hoisted_1$3n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3n = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$3n(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3n, [
    _hoisted_2$3n
  ]))
}

script$3n.render = render$3n;
script$3n.__file = "lib/components/Icons/Outline/OXCircle.vue";

var script$3o = defineComponent({
  name: 'OLightningBolt'
});

const _hoisted_1$3o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3o = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 10V3L4 14h7v7l9-11h-7z"
}, null, -1 /* HOISTED */);

function render$3o(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3o, [
    _hoisted_2$3o
  ]))
}

script$3o.render = render$3o;
script$3o.__file = "lib/components/Icons/Outline/OLightningBolt.vue";

var script$3p = defineComponent({
  name: 'OGlobe'
});

const _hoisted_1$3p = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3p = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$3p(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3p, [
    _hoisted_2$3p
  ]))
}

script$3p.render = render$3p;
script$3p.__file = "lib/components/Icons/Outline/OGlobe.vue";

var script$3q = defineComponent({
  name: 'OArrowUp'
});

const _hoisted_1$3q = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3q = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 10l7-7m0 0l7 7m-7-7v18"
}, null, -1 /* HOISTED */);

function render$3q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3q, [
    _hoisted_2$3q
  ]))
}

script$3q.render = render$3q;
script$3q.__file = "lib/components/Icons/Outline/OArrowUp.vue";

var script$3r = defineComponent({
  name: 'OInformationCircle'
});

const _hoisted_1$3r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3r = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1 /* HOISTED */);

function render$3r(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3r, [
    _hoisted_2$3r
  ]))
}

script$3r.render = render$3r;
script$3r.__file = "lib/components/Icons/Outline/OInformationCircle.vue";

var script$3s = defineComponent({
  name: 'OCheck'
});

const _hoisted_1$3s = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3s = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 13l4 4L19 7"
}, null, -1 /* HOISTED */);

function render$3s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3s, [
    _hoisted_2$3s
  ]))
}

script$3s.render = render$3s;
script$3s.__file = "lib/components/Icons/Outline/OCheck.vue";

var script$3t = defineComponent({
  name: 'OTicket'
});

const _hoisted_1$3t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3t = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
}, null, -1 /* HOISTED */);

function render$3t(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3t, [
    _hoisted_2$3t
  ]))
}

script$3t.render = render$3t;
script$3t.__file = "lib/components/Icons/Outline/OTicket.vue";

var script$3u = defineComponent({
  name: 'OSwitchHorizontal'
});

const _hoisted_1$3u = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3u = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
}, null, -1 /* HOISTED */);

function render$3u(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3u, [
    _hoisted_2$3u
  ]))
}

script$3u.render = render$3u;
script$3u.__file = "lib/components/Icons/Outline/OSwitchHorizontal.vue";

var script$3v = defineComponent({
  name: 'OPlus'
});

const _hoisted_1$3v = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3v = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
}, null, -1 /* HOISTED */);

function render$3v(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3v, [
    _hoisted_2$3v
  ]))
}

script$3v.render = render$3v;
script$3v.__file = "lib/components/Icons/Outline/OPlus.vue";

var script$3w = defineComponent({
  name: 'OMailOpen'
});

const _hoisted_1$3w = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3w = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
}, null, -1 /* HOISTED */);

function render$3w(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3w, [
    _hoisted_2$3w
  ]))
}

script$3w.render = render$3w;
script$3w.__file = "lib/components/Icons/Outline/OMailOpen.vue";

var script$3x = defineComponent({
  name: 'OFolderDownload'
});

const _hoisted_1$3x = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_2$3x = /*#__PURE__*/createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
}, null, -1 /* HOISTED */);

function render$3x(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3x, [
    _hoisted_2$3x
  ]))
}

script$3x.render = render$3x;
script$3x.__file = "lib/components/Icons/Outline/OFolderDownload.vue";

var script$3y = defineComponent({
  name: 'SCalculator'
});

const _hoisted_1$3y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3y = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm6 7a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 3a1 1 0 100 2h.01a1 1 0 100-2H10zm-4 1a1 1 0 011-1h.01a1 1 0 110 2H7a1 1 0 01-1-1zm1-4a1 1 0 100 2h.01a1 1 0 100-2H7zm2 1a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm4-4a1 1 0 100 2h.01a1 1 0 100-2H13zM9 9a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zM7 8a1 1 0 000 2h.01a1 1 0 000-2H7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3y, [
    _hoisted_2$3y
  ]))
}

script$3y.render = render$3y;
script$3y.__file = "lib/components/Icons/Solid/SCalculator.vue";

var script$3z = defineComponent({
  name: 'SFlag'
});

const _hoisted_1$3z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3z = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3z, [
    _hoisted_2$3z
  ]))
}

script$3z.render = render$3z;
script$3z.__file = "lib/components/Icons/Solid/SFlag.vue";

var script$3A = defineComponent({
  name: 'SNewspaper'
});

const _hoisted_1$3A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3A = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h6v4H5V6zm6 6H5v2h6v-2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$b = /*#__PURE__*/createVNode("path", { d: "M15 7h1a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0V7z" }, null, -1 /* HOISTED */);

function render$3A(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3A, [
    _hoisted_2$3A,
    _hoisted_3$b
  ]))
}

script$3A.render = render$3A;
script$3A.__file = "lib/components/Icons/Solid/SNewspaper.vue";

var script$3B = defineComponent({
  name: 'SDatabase'
});

const _hoisted_1$3B = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3B = /*#__PURE__*/createVNode("path", { d: "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" }, null, -1 /* HOISTED */);
const _hoisted_3$c = /*#__PURE__*/createVNode("path", { d: "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" }, null, -1 /* HOISTED */);
const _hoisted_4$1 = /*#__PURE__*/createVNode("path", { d: "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" }, null, -1 /* HOISTED */);

function render$3B(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3B, [
    _hoisted_2$3B,
    _hoisted_3$c,
    _hoisted_4$1
  ]))
}

script$3B.render = render$3B;
script$3B.__file = "lib/components/Icons/Solid/SDatabase.vue";

var script$3C = defineComponent({
  name: 'SVideoCamera'
});

const _hoisted_1$3C = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3C = /*#__PURE__*/createVNode("path", { d: "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" }, null, -1 /* HOISTED */);

function render$3C(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3C, [
    _hoisted_2$3C
  ]))
}

script$3C.render = render$3C;
script$3C.__file = "lib/components/Icons/Solid/SVideoCamera.vue";

var script$3D = defineComponent({
  name: 'SAcademicCap'
});

const _hoisted_1$3D = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3D = /*#__PURE__*/createVNode("path", { d: "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" }, null, -1 /* HOISTED */);

function render$3D(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3D, [
    _hoisted_2$3D
  ]))
}

script$3D.render = render$3D;
script$3D.__file = "lib/components/Icons/Solid/SAcademicCap.vue";

var script$3E = defineComponent({
  name: 'SBriefcase'
});

const _hoisted_1$3E = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3E = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$d = /*#__PURE__*/createVNode("path", { d: "M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" }, null, -1 /* HOISTED */);

function render$3E(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3E, [
    _hoisted_2$3E,
    _hoisted_3$d
  ]))
}

script$3E.render = render$3E;
script$3E.__file = "lib/components/Icons/Solid/SBriefcase.vue";

var script$3F = defineComponent({
  name: 'SMenuAlt4'
});

const _hoisted_1$3F = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3F = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3F(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3F, [
    _hoisted_2$3F
  ]))
}

script$3F.render = render$3F;
script$3F.__file = "lib/components/Icons/Solid/SMenuAlt4.vue";

var script$3G = defineComponent({
  name: 'STag'
});

const _hoisted_1$3G = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3G = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3G(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3G, [
    _hoisted_2$3G
  ]))
}

script$3G.render = render$3G;
script$3G.__file = "lib/components/Icons/Solid/STag.vue";

var script$3H = defineComponent({
  name: 'SUserAdd'
});

const _hoisted_1$3H = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3H = /*#__PURE__*/createVNode("path", { d: "M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" }, null, -1 /* HOISTED */);

function render$3H(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3H, [
    _hoisted_2$3H
  ]))
}

script$3H.render = render$3H;
script$3H.__file = "lib/components/Icons/Solid/SUserAdd.vue";

var script$3I = defineComponent({
  name: 'SMap'
});

const _hoisted_1$3I = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3I = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3I, [
    _hoisted_2$3I
  ]))
}

script$3I.render = render$3I;
script$3I.__file = "lib/components/Icons/Solid/SMap.vue";

var script$3J = defineComponent({
  name: 'SColorSwatch'
});

const _hoisted_1$3J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3J = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3J(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3J, [
    _hoisted_2$3J
  ]))
}

script$3J.render = render$3J;
script$3J.__file = "lib/components/Icons/Solid/SColorSwatch.vue";

var script$3K = defineComponent({
  name: 'SCurrencyRupee'
});

const _hoisted_1$3K = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3K = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 5a1 1 0 100 2h1a2 2 0 011.732 1H7a1 1 0 100 2h2.732A2 2 0 018 11H7a1 1 0 00-.707 1.707l3 3a1 1 0 001.414-1.414l-1.483-1.484A4.008 4.008 0 0011.874 10H13a1 1 0 100-2h-1.126a3.976 3.976 0 00-.41-1H13a1 1 0 100-2H7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3K(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3K, [
    _hoisted_2$3K
  ]))
}

script$3K.render = render$3K;
script$3K.__file = "lib/components/Icons/Solid/SCurrencyRupee.vue";

var script$3L = defineComponent({
  name: 'SRss'
});

const _hoisted_1$3L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3L = /*#__PURE__*/createVNode("path", { d: "M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z" }, null, -1 /* HOISTED */);
const _hoisted_3$e = /*#__PURE__*/createVNode("path", { d: "M4 9a1 1 0 011-1 7 7 0 017 7 1 1 0 11-2 0 5 5 0 00-5-5 1 1 0 01-1-1zM3 15a2 2 0 114 0 2 2 0 01-4 0z" }, null, -1 /* HOISTED */);

function render$3L(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3L, [
    _hoisted_2$3L,
    _hoisted_3$e
  ]))
}

script$3L.render = render$3L;
script$3L.__file = "lib/components/Icons/Solid/SRss.vue";

var script$3M = defineComponent({
  name: 'SArrowNarrowUp'
});

const _hoisted_1$3M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3M = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3M(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3M, [
    _hoisted_2$3M
  ]))
}

script$3M.render = render$3M;
script$3M.__file = "lib/components/Icons/Solid/SArrowNarrowUp.vue";

var script$3N = defineComponent({
  name: 'SCamera'
});

const _hoisted_1$3N = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3N = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3N(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3N, [
    _hoisted_2$3N
  ]))
}

script$3N.render = render$3N;
script$3N.__file = "lib/components/Icons/Solid/SCamera.vue";

var script$3O = defineComponent({
  name: 'SPlusSm'
});

const _hoisted_1$3O = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3O = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3O(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3O, [
    _hoisted_2$3O
  ]))
}

script$3O.render = render$3O;
script$3O.__file = "lib/components/Icons/Solid/SPlusSm.vue";

var script$3P = defineComponent({
  name: 'SArrowCircleDown'
});

const _hoisted_1$3P = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3P = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3P(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3P, [
    _hoisted_2$3P
  ]))
}

script$3P.render = render$3P;
script$3P.__file = "lib/components/Icons/Solid/SArrowCircleDown.vue";

var script$3Q = defineComponent({
  name: 'SFilter'
});

const _hoisted_1$3Q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3Q = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3Q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3Q, [
    _hoisted_2$3Q
  ]))
}

script$3Q.render = render$3Q;
script$3Q.__file = "lib/components/Icons/Solid/SFilter.vue";

var script$3R = defineComponent({
  name: 'SPhoneMissedCall'
});

const _hoisted_1$3R = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3R = /*#__PURE__*/createVNode("path", { d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" }, null, -1 /* HOISTED */);
const _hoisted_3$f = /*#__PURE__*/createVNode("path", { d: "M16.707 3.293a1 1 0 010 1.414L15.414 6l1.293 1.293a1 1 0 01-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 11-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 011.414-1.414L14 4.586l1.293-1.293a1 1 0 011.414 0z" }, null, -1 /* HOISTED */);

function render$3R(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3R, [
    _hoisted_2$3R,
    _hoisted_3$f
  ]))
}

script$3R.render = render$3R;
script$3R.__file = "lib/components/Icons/Solid/SPhoneMissedCall.vue";

var script$3S = defineComponent({
  name: 'SLockOpen'
});

const _hoisted_1$3S = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3S = /*#__PURE__*/createVNode("path", { d: "M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z" }, null, -1 /* HOISTED */);

function render$3S(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3S, [
    _hoisted_2$3S
  ]))
}

script$3S.render = render$3S;
script$3S.__file = "lib/components/Icons/Solid/SLockOpen.vue";

var script$3T = defineComponent({
  name: 'STemplate'
});

const _hoisted_1$3T = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3T = /*#__PURE__*/createVNode("path", { d: "M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" }, null, -1 /* HOISTED */);

function render$3T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3T, [
    _hoisted_2$3T
  ]))
}

script$3T.render = render$3T;
script$3T.__file = "lib/components/Icons/Solid/STemplate.vue";

var script$3U = defineComponent({
  name: 'SDocumentDownload'
});

const _hoisted_1$3U = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3U = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3U(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3U, [
    _hoisted_2$3U
  ]))
}

script$3U.render = render$3U;
script$3U.__file = "lib/components/Icons/Solid/SDocumentDownload.vue";

var script$3V = defineComponent({
  name: 'SFilm'
});

const _hoisted_1$3V = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3V = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm3 2h6v4H7V5zm8 8v2h1v-2h-1zm-2-2H7v4h6v-4zm2 0h1V9h-1v2zm1-4V5h-1v2h1zM5 5v2H4V5h1zm0 4H4v2h1V9zm-1 4h1v2H4v-2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3V(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3V, [
    _hoisted_2$3V
  ]))
}

script$3V.render = render$3V;
script$3V.__file = "lib/components/Icons/Solid/SFilm.vue";

var script$3W = defineComponent({
  name: 'SOfficeBuilding'
});

const _hoisted_1$3W = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3W = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3W(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3W, [
    _hoisted_2$3W
  ]))
}

script$3W.render = render$3W;
script$3W.__file = "lib/components/Icons/Solid/SOfficeBuilding.vue";

var script$3X = defineComponent({
  name: 'SReceiptTax'
});

const _hoisted_1$3X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3X = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm2.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.207.293a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414zM12.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3X(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3X, [
    _hoisted_2$3X
  ]))
}

script$3X.render = render$3X;
script$3X.__file = "lib/components/Icons/Solid/SReceiptTax.vue";

var script$3Y = defineComponent({
  name: 'SReply'
});

const _hoisted_1$3Y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3Y = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3Y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3Y, [
    _hoisted_2$3Y
  ]))
}

script$3Y.render = render$3Y;
script$3Y.__file = "lib/components/Icons/Solid/SReply.vue";

var script$3Z = defineComponent({
  name: 'SPause'
});

const _hoisted_1$3Z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3Z = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3Z, [
    _hoisted_2$3Z
  ]))
}

script$3Z.render = render$3Z;
script$3Z.__file = "lib/components/Icons/Solid/SPause.vue";

var script$3_ = defineComponent({
  name: 'SSave'
});

const _hoisted_1$3_ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3_ = /*#__PURE__*/createVNode("path", { d: "M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z" }, null, -1 /* HOISTED */);

function render$3_(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3_, [
    _hoisted_2$3_
  ]))
}

script$3_.render = render$3_;
script$3_.__file = "lib/components/Icons/Solid/SSave.vue";

var script$3$ = defineComponent({
  name: 'SStop'
});

const _hoisted_1$3$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$3$ = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$3$(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$3$, [
    _hoisted_2$3$
  ]))
}

script$3$.render = render$3$;
script$3$.__file = "lib/components/Icons/Solid/SStop.vue";

var script$40 = defineComponent({
  name: 'SServer'
});

const _hoisted_1$40 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$40 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$40(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$40, [
    _hoisted_2$40
  ]))
}

script$40.render = render$40;
script$40.__file = "lib/components/Icons/Solid/SServer.vue";

var script$41 = defineComponent({
  name: 'SWifi'
});

const _hoisted_1$41 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$41 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 01.808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 01-1.414 1.414zM14.95 11.05a7 7 0 00-9.9 0 1 1 0 01-1.414-1.414 9 9 0 0112.728 0 1 1 0 01-1.414 1.414zM12.12 13.88a3 3 0 00-4.242 0 1 1 0 01-1.415-1.415 5 5 0 017.072 0 1 1 0 01-1.415 1.415zM9 16a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$41(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$41, [
    _hoisted_2$41
  ]))
}

script$41.render = render$41;
script$41.__file = "lib/components/Icons/Solid/SWifi.vue";

var script$42 = defineComponent({
  name: 'SEyeOff'
});

const _hoisted_1$42 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$42 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$g = /*#__PURE__*/createVNode("path", { d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" }, null, -1 /* HOISTED */);

function render$42(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$42, [
    _hoisted_2$42,
    _hoisted_3$g
  ]))
}

script$42.render = render$42;
script$42.__file = "lib/components/Icons/Solid/SEyeOff.vue";

var script$43 = defineComponent({
  name: 'SEmojiHappy'
});

const _hoisted_1$43 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$43 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$43(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$43, [
    _hoisted_2$43
  ]))
}

script$43.render = render$43;
script$43.__file = "lib/components/Icons/Solid/SEmojiHappy.vue";

var script$44 = defineComponent({
  name: 'SCalendar'
});

const _hoisted_1$44 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$44 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$44(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$44, [
    _hoisted_2$44
  ]))
}

script$44.render = render$44;
script$44.__file = "lib/components/Icons/Solid/SCalendar.vue";

var script$45 = defineComponent({
  name: 'SFingerPrint'
});

const _hoisted_1$45 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$45 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$h = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11zm8.921 2.012a1 1 0 01.831 1.145 19.86 19.86 0 01-.545 2.436 1 1 0 11-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 011.144-.83z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_4$2 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 10a1 1 0 011 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 01-1.838-.789A13.952 13.952 0 009 11a1 1 0 011-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$45(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$45, [
    _hoisted_2$45,
    _hoisted_3$h,
    _hoisted_4$2
  ]))
}

script$45.render = render$45;
script$45.__file = "lib/components/Icons/Solid/SFingerPrint.vue";

var script$46 = defineComponent({
  name: 'SClock'
});

const _hoisted_1$46 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$46 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$46(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$46, [
    _hoisted_2$46
  ]))
}

script$46.render = render$46;
script$46.__file = "lib/components/Icons/Solid/SClock.vue";

var script$47 = defineComponent({
  name: 'SMoon'
});

const _hoisted_1$47 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$47 = /*#__PURE__*/createVNode("path", { d: "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" }, null, -1 /* HOISTED */);

function render$47(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$47, [
    _hoisted_2$47
  ]))
}

script$47.render = render$47;
script$47.__file = "lib/components/Icons/Solid/SMoon.vue";

var script$48 = defineComponent({
  name: 'SPlay'
});

const _hoisted_1$48 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$48 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$48(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$48, [
    _hoisted_2$48
  ]))
}

script$48.render = render$48;
script$48.__file = "lib/components/Icons/Solid/SPlay.vue";

var script$49 = defineComponent({
  name: 'SArrowCircleRight'
});

const _hoisted_1$49 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$49 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$49(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$49, [
    _hoisted_2$49
  ]))
}

script$49.render = render$49;
script$49.__file = "lib/components/Icons/Solid/SArrowCircleRight.vue";

var script$4a = defineComponent({
  name: 'SSearchCircle'
});

const _hoisted_1$4a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4a = /*#__PURE__*/createVNode("path", { d: "M9 9a2 2 0 114 0 2 2 0 01-4 0z" }, null, -1 /* HOISTED */);
const _hoisted_3$i = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4a, [
    _hoisted_2$4a,
    _hoisted_3$i
  ]))
}

script$4a.render = render$4a;
script$4a.__file = "lib/components/Icons/Solid/SSearchCircle.vue";

var script$4b = defineComponent({
  name: 'SAtSymbol'
});

const _hoisted_1$4b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4b = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4b, [
    _hoisted_2$4b
  ]))
}

script$4b.render = render$4b;
script$4b.__file = "lib/components/Icons/Solid/SAtSymbol.vue";

var script$4c = defineComponent({
  name: 'SPrinter'
});

const _hoisted_1$4c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4c = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4c, [
    _hoisted_2$4c
  ]))
}

script$4c.render = render$4c;
script$4c.__file = "lib/components/Icons/Solid/SPrinter.vue";

var script$4d = defineComponent({
  name: 'SMicrophone'
});

const _hoisted_1$4d = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4d = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4d, [
    _hoisted_2$4d
  ]))
}

script$4d.render = render$4d;
script$4d.__file = "lib/components/Icons/Solid/SMicrophone.vue";

var script$4e = defineComponent({
  name: 'SRewind'
});

const _hoisted_1$4e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4e = /*#__PURE__*/createVNode("path", { d: "M8.445 14.832A1 1 0 0010 14v-2.798l5.445 3.63A1 1 0 0017 14V6a1 1 0 00-1.555-.832L10 8.798V6a1 1 0 00-1.555-.832l-6 4a1 1 0 000 1.664l6 4z" }, null, -1 /* HOISTED */);

function render$4e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4e, [
    _hoisted_2$4e
  ]))
}

script$4e.render = render$4e;
script$4e.__file = "lib/components/Icons/Solid/SRewind.vue";

var script$4f = defineComponent({
  name: 'SLocationMarker'
});

const _hoisted_1$4f = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4f = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4f, [
    _hoisted_2$4f
  ]))
}

script$4f.render = render$4f;
script$4f.__file = "lib/components/Icons/Solid/SLocationMarker.vue";

var script$4g = defineComponent({
  name: 'SHeart'
});

const _hoisted_1$4g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4g = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4g, [
    _hoisted_2$4g
  ]))
}

script$4g.render = render$4g;
script$4g.__file = "lib/components/Icons/Solid/SHeart.vue";

var script$4h = defineComponent({
  name: 'STrendingUp'
});

const _hoisted_1$4h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4h = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4h(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4h, [
    _hoisted_2$4h
  ]))
}

script$4h.render = render$4h;
script$4h.__file = "lib/components/Icons/Solid/STrendingUp.vue";

var script$4i = defineComponent({
  name: 'SMinus'
});

const _hoisted_1$4i = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4i = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4i(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4i, [
    _hoisted_2$4i
  ]))
}

script$4i.render = render$4i;
script$4i.__file = "lib/components/Icons/Solid/SMinus.vue";

var script$4j = defineComponent({
  name: 'SDeviceTablet'
});

const _hoisted_1$4j = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4j = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm4 14a1 1 0 100-2 1 1 0 000 2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4j, [
    _hoisted_2$4j
  ]))
}

script$4j.render = render$4j;
script$4j.__file = "lib/components/Icons/Solid/SDeviceTablet.vue";

var script$4k = defineComponent({
  name: 'SSearch'
});

const _hoisted_1$4k = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4k = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4k, [
    _hoisted_2$4k
  ]))
}

script$4k.render = render$4k;
script$4k.__file = "lib/components/Icons/Solid/SSearch.vue";

var script$4l = defineComponent({
  name: 'SScale'
});

const _hoisted_1$4l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4l = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1zm-5 8.274l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274zm10 0l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4l, [
    _hoisted_2$4l
  ]))
}

script$4l.render = render$4l;
script$4l.__file = "lib/components/Icons/Solid/SScale.vue";

var script$4m = defineComponent({
  name: 'SChip'
});

const _hoisted_1$4m = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4m = /*#__PURE__*/createVNode("path", { d: "M13 7H7v6h6V7z" }, null, -1 /* HOISTED */);
const _hoisted_3$j = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4m(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4m, [
    _hoisted_2$4m,
    _hoisted_3$j
  ]))
}

script$4m.render = render$4m;
script$4m.__file = "lib/components/Icons/Solid/SChip.vue";

var script$4n = defineComponent({
  name: 'SCloudUpload'
});

const _hoisted_1$4n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4n = /*#__PURE__*/createVNode("path", { d: "M5.5 13a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 13H11V9.413l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13H5.5z" }, null, -1 /* HOISTED */);
const _hoisted_3$k = /*#__PURE__*/createVNode("path", { d: "M9 13h2v5a1 1 0 11-2 0v-5z" }, null, -1 /* HOISTED */);

function render$4n(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4n, [
    _hoisted_2$4n,
    _hoisted_3$k
  ]))
}

script$4n.render = render$4n;
script$4n.__file = "lib/components/Icons/Solid/SCloudUpload.vue";

var script$4o = defineComponent({
  name: 'SPlusCircle'
});

const _hoisted_1$4o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4o = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4o(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4o, [
    _hoisted_2$4o
  ]))
}

script$4o.render = render$4o;
script$4o.__file = "lib/components/Icons/Solid/SPlusCircle.vue";

var script$4p = defineComponent({
  name: 'SCurrencyYen'
});

const _hoisted_1$4p = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4p = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7.858 5.485a1 1 0 00-1.715 1.03L7.633 9H7a1 1 0 100 2h1.834l.166.277V12H7a1 1 0 100 2h2v1a1 1 0 102 0v-1h2a1 1 0 100-2h-2v-.723l.166-.277H13a1 1 0 100-2h-.634l1.492-2.486a1 1 0 10-1.716-1.029L10.034 9h-.068L7.858 5.485z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4p(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4p, [
    _hoisted_2$4p
  ]))
}

script$4p.render = render$4p;
script$4p.__file = "lib/components/Icons/Solid/SCurrencyYen.vue";

var script$4q = defineComponent({
  name: 'SSpeakerphone'
});

const _hoisted_1$4q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4q = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4q, [
    _hoisted_2$4q
  ]))
}

script$4q.render = render$4q;
script$4q.__file = "lib/components/Icons/Solid/SSpeakerphone.vue";

var script$4r = defineComponent({
  name: 'STruck'
});

const _hoisted_1$4r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4r = /*#__PURE__*/createVNode("path", { d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }, null, -1 /* HOISTED */);
const _hoisted_3$l = /*#__PURE__*/createVNode("path", { d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" }, null, -1 /* HOISTED */);

function render$4r(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4r, [
    _hoisted_2$4r,
    _hoisted_3$l
  ]))
}

script$4r.render = render$4r;
script$4r.__file = "lib/components/Icons/Solid/STruck.vue";

var script$4s = defineComponent({
  name: 'SFolderAdd'
});

const _hoisted_1$4s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4s = /*#__PURE__*/createVNode("path", { d: "M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" }, null, -1 /* HOISTED */);
const _hoisted_3$m = /*#__PURE__*/createVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 11h4m-2-2v4"
}, null, -1 /* HOISTED */);

function render$4s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4s, [
    _hoisted_2$4s,
    _hoisted_3$m
  ]))
}

script$4s.render = render$4s;
script$4s.__file = "lib/components/Icons/Solid/SFolderAdd.vue";

var script$4t = defineComponent({
  name: 'SEye'
});

const _hoisted_1$4t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4t = /*#__PURE__*/createVNode("path", { d: "M10 12a2 2 0 100-4 2 2 0 000 4z" }, null, -1 /* HOISTED */);
const _hoisted_3$n = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4t(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4t, [
    _hoisted_2$4t,
    _hoisted_3$n
  ]))
}

script$4t.render = render$4t;
script$4t.__file = "lib/components/Icons/Solid/SEye.vue";

var script$4u = defineComponent({
  name: 'SPencil'
});

const _hoisted_1$4u = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4u = /*#__PURE__*/createVNode("path", { d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" }, null, -1 /* HOISTED */);

function render$4u(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4u, [
    _hoisted_2$4u
  ]))
}

script$4u.render = render$4u;
script$4u.__file = "lib/components/Icons/Solid/SPencil.vue";

var script$4v = defineComponent({
  name: 'SCurrencyEuro'
});

const _hoisted_1$4v = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4v = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 001.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 000 2h.013a9.358 9.358 0 000 1H6a1 1 0 100 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 10-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 01-.264-.521H10a1 1 0 100-2H8.017a7.36 7.36 0 010-1H10a1 1 0 100-2H8.472c.08-.185.167-.36.264-.521z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4v(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4v, [
    _hoisted_2$4v
  ]))
}

script$4v.render = render$4v;
script$4v.__file = "lib/components/Icons/Solid/SCurrencyEuro.vue";

var script$4w = defineComponent({
  name: 'SGift'
});

const _hoisted_1$4w = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4w = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$o = /*#__PURE__*/createVNode("path", { d: "M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z" }, null, -1 /* HOISTED */);

function render$4w(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4w, [
    _hoisted_2$4w,
    _hoisted_3$o
  ]))
}

script$4w.render = render$4w;
script$4w.__file = "lib/components/Icons/Solid/SGift.vue";

var script$4x = defineComponent({
  name: 'SChevronDoubleDown'
});

const _hoisted_1$4x = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4x = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4x(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4x, [
    _hoisted_2$4x
  ]))
}

script$4x.render = render$4x;
script$4x.__file = "lib/components/Icons/Solid/SChevronDoubleDown.vue";

var script$4y = defineComponent({
  name: 'SCube'
});

const _hoisted_1$4y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4y = /*#__PURE__*/createVNode("path", { d: "M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" }, null, -1 /* HOISTED */);

function render$4y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4y, [
    _hoisted_2$4y
  ]))
}

script$4y.render = render$4y;
script$4y.__file = "lib/components/Icons/Solid/SCube.vue";

var script$4z = defineComponent({
  name: 'SDocumentReport'
});

const _hoisted_1$4z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4z = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4z, [
    _hoisted_2$4z
  ]))
}

script$4z.render = render$4z;
script$4z.__file = "lib/components/Icons/Solid/SDocumentReport.vue";

var script$4A = defineComponent({
  name: 'SDocumentSearch'
});

const _hoisted_1$4A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4A = /*#__PURE__*/createVNode("path", { d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z" }, null, -1 /* HOISTED */);
const _hoisted_3$p = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4A(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4A, [
    _hoisted_2$4A,
    _hoisted_3$p
  ]))
}

script$4A.render = render$4A;
script$4A.__file = "lib/components/Icons/Solid/SDocumentSearch.vue";

var script$4B = defineComponent({
  name: 'SDesktopComputer'
});

const _hoisted_1$4B = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4B = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4B(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4B, [
    _hoisted_2$4B
  ]))
}

script$4B.render = render$4B;
script$4B.__file = "lib/components/Icons/Solid/SDesktopComputer.vue";

var script$4C = defineComponent({
  name: 'SArrowCircleLeft'
});

const _hoisted_1$4C = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4C = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4C(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4C, [
    _hoisted_2$4C
  ]))
}

script$4C.render = render$4C;
script$4C.__file = "lib/components/Icons/Solid/SArrowCircleLeft.vue";

var script$4D = defineComponent({
  name: 'SArrowNarrowDown'
});

const _hoisted_1$4D = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4D = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4D(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4D, [
    _hoisted_2$4D
  ]))
}

script$4D.render = render$4D;
script$4D.__file = "lib/components/Icons/Solid/SArrowNarrowDown.vue";

var script$4E = defineComponent({
  name: 'SAdjustments'
});

const _hoisted_1$4E = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4E = /*#__PURE__*/createVNode("path", { d: "M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" }, null, -1 /* HOISTED */);

function render$4E(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4E, [
    _hoisted_2$4E
  ]))
}

script$4E.render = render$4E;
script$4E.__file = "lib/components/Icons/Solid/SAdjustments.vue";

var script$4F = defineComponent({
  name: 'SSwitchVertical'
});

const _hoisted_1$4F = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4F = /*#__PURE__*/createVNode("path", { d: "M5 12a1 1 0 102 0V6.414l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L5 6.414V12zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z" }, null, -1 /* HOISTED */);

function render$4F(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4F, [
    _hoisted_2$4F
  ]))
}

script$4F.render = render$4F;
script$4F.__file = "lib/components/Icons/Solid/SSwitchVertical.vue";

var script$4G = defineComponent({
  name: 'SMail'
});

const _hoisted_1$4G = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4G = /*#__PURE__*/createVNode("path", { d: "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" }, null, -1 /* HOISTED */);
const _hoisted_3$q = /*#__PURE__*/createVNode("path", { d: "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" }, null, -1 /* HOISTED */);

function render$4G(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4G, [
    _hoisted_2$4G,
    _hoisted_3$q
  ]))
}

script$4G.render = render$4G;
script$4G.__file = "lib/components/Icons/Solid/SMail.vue";

var script$4H = defineComponent({
  name: 'SHashtag'
});

const _hoisted_1$4H = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4H = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4H(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4H, [
    _hoisted_2$4H
  ]))
}

script$4H.render = render$4H;
script$4H.__file = "lib/components/Icons/Solid/SHashtag.vue";

var script$4I = defineComponent({
  name: 'SCurrencyDollar'
});

const _hoisted_1$4I = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4I = /*#__PURE__*/createVNode("path", { d: "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" }, null, -1 /* HOISTED */);
const _hoisted_3$r = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4I, [
    _hoisted_2$4I,
    _hoisted_3$r
  ]))
}

script$4I.render = render$4I;
script$4I.__file = "lib/components/Icons/Solid/SCurrencyDollar.vue";

var script$4J = defineComponent({
  name: 'SSortDescending'
});

const _hoisted_1$4J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4J = /*#__PURE__*/createVNode("path", { d: "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z" }, null, -1 /* HOISTED */);

function render$4J(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4J, [
    _hoisted_2$4J
  ]))
}

script$4J.render = render$4J;
script$4J.__file = "lib/components/Icons/Solid/SSortDescending.vue";

var script$4K = defineComponent({
  name: 'SMenuAlt2'
});

const _hoisted_1$4K = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4K = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4K(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4K, [
    _hoisted_2$4K
  ]))
}

script$4K.render = render$4K;
script$4K.__file = "lib/components/Icons/Solid/SMenuAlt2.vue";

var script$4L = defineComponent({
  name: 'SChartSquareBar'
});

const _hoisted_1$4L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4L = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4L(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4L, [
    _hoisted_2$4L
  ]))
}

script$4L.render = render$4L;
script$4L.__file = "lib/components/Icons/Solid/SChartSquareBar.vue";

var script$4M = defineComponent({
  name: 'SArchive'
});

const _hoisted_1$4M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4M = /*#__PURE__*/createVNode("path", { d: "M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" }, null, -1 /* HOISTED */);
const _hoisted_3$s = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4M(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4M, [
    _hoisted_2$4M,
    _hoisted_3$s
  ]))
}

script$4M.render = render$4M;
script$4M.__file = "lib/components/Icons/Solid/SArchive.vue";

var script$4N = defineComponent({
  name: 'SMusicNote'
});

const _hoisted_1$4N = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4N = /*#__PURE__*/createVNode("path", { d: "M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" }, null, -1 /* HOISTED */);

function render$4N(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4N, [
    _hoisted_2$4N
  ]))
}

script$4N.render = render$4N;
script$4N.__file = "lib/components/Icons/Solid/SMusicNote.vue";

var script$4O = defineComponent({
  name: 'SPresentationChartLine'
});

const _hoisted_1$4O = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4O = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4O(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4O, [
    _hoisted_2$4O
  ]))
}

script$4O.render = render$4O;
script$4O.__file = "lib/components/Icons/Solid/SPresentationChartLine.vue";

var script$4P = defineComponent({
  name: 'SViewBoards'
});

const _hoisted_1$4P = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4P = /*#__PURE__*/createVNode("path", { d: "M2 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V4zM8 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM15 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2z" }, null, -1 /* HOISTED */);

function render$4P(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4P, [
    _hoisted_2$4P
  ]))
}

script$4P.render = render$4P;
script$4P.__file = "lib/components/Icons/Solid/SViewBoards.vue";

var script$4Q = defineComponent({
  name: 'SMenuAlt1'
});

const _hoisted_1$4Q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4Q = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4Q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4Q, [
    _hoisted_2$4Q
  ]))
}

script$4Q.render = render$4Q;
script$4Q.__file = "lib/components/Icons/Solid/SMenuAlt1.vue";

var script$4R = defineComponent({
  name: 'SKey'
});

const _hoisted_1$4R = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4R = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4R(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4R, [
    _hoisted_2$4R
  ]))
}

script$4R.render = render$4R;
script$4R.__file = "lib/components/Icons/Solid/SKey.vue";

var script$4S = defineComponent({
  name: 'SCollection'
});

const _hoisted_1$4S = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4S = /*#__PURE__*/createVNode("path", { d: "M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" }, null, -1 /* HOISTED */);

function render$4S(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4S, [
    _hoisted_2$4S
  ]))
}

script$4S.render = render$4S;
script$4S.__file = "lib/components/Icons/Solid/SCollection.vue";

var script$4T = defineComponent({
  name: 'SReceiptRefund'
});

const _hoisted_1$4T = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4T = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4T, [
    _hoisted_2$4T
  ]))
}

script$4T.render = render$4T;
script$4T.__file = "lib/components/Icons/Solid/SReceiptRefund.vue";

var script$4U = defineComponent({
  name: 'SCode'
});

const _hoisted_1$4U = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4U = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4U(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4U, [
    _hoisted_2$4U
  ]))
}

script$4U.render = render$4U;
script$4U.__file = "lib/components/Icons/Solid/SCode.vue";

var script$4V = defineComponent({
  name: 'SViewList'
});

const _hoisted_1$4V = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4V = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4V(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4V, [
    _hoisted_2$4V
  ]))
}

script$4V.render = render$4V;
script$4V.__file = "lib/components/Icons/Solid/SViewList.vue";

var script$4W = defineComponent({
  name: 'SLink'
});

const _hoisted_1$4W = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4W = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4W(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4W, [
    _hoisted_2$4W
  ]))
}

script$4W.render = render$4W;
script$4W.__file = "lib/components/Icons/Solid/SLink.vue";

var script$4X = defineComponent({
  name: 'SChatAlt'
});

const _hoisted_1$4X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4X = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4X(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4X, [
    _hoisted_2$4X
  ]))
}

script$4X.render = render$4X;
script$4X.__file = "lib/components/Icons/Solid/SChatAlt.vue";

var script$4Y = defineComponent({
  name: 'SArrowDown'
});

const _hoisted_1$4Y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4Y = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4Y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4Y, [
    _hoisted_2$4Y
  ]))
}

script$4Y.render = render$4Y;
script$4Y.__file = "lib/components/Icons/Solid/SArrowDown.vue";

var script$4Z = defineComponent({
  name: 'SChevronDoubleUp'
});

const _hoisted_1$4Z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4Z = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4Z, [
    _hoisted_2$4Z
  ]))
}

script$4Z.render = render$4Z;
script$4Z.__file = "lib/components/Icons/Solid/SChevronDoubleUp.vue";

var script$4_ = defineComponent({
  name: 'SStatusOffline'
});

const _hoisted_1$4_ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4_ = /*#__PURE__*/createVNode("path", { d: "M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z" }, null, -1 /* HOISTED */);

function render$4_(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4_, [
    _hoisted_2$4_
  ]))
}

script$4_.render = render$4_;
script$4_.__file = "lib/components/Icons/Solid/SStatusOffline.vue";

var script$4$ = defineComponent({
  name: 'SPhotograph'
});

const _hoisted_1$4$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$4$ = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$4$(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$4$, [
    _hoisted_2$4$
  ]))
}

script$4$.render = render$4$;
script$4$.__file = "lib/components/Icons/Solid/SPhotograph.vue";

var script$50 = defineComponent({
  name: 'SCreditCard'
});

const _hoisted_1$50 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$50 = /*#__PURE__*/createVNode("path", { d: "M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" }, null, -1 /* HOISTED */);
const _hoisted_3$t = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$50(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$50, [
    _hoisted_2$50,
    _hoisted_3$t
  ]))
}

script$50.render = render$50;
script$50.__file = "lib/components/Icons/Solid/SCreditCard.vue";

var script$51 = defineComponent({
  name: 'SViewGrid'
});

const _hoisted_1$51 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$51 = /*#__PURE__*/createVNode("path", { d: "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" }, null, -1 /* HOISTED */);

function render$51(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$51, [
    _hoisted_2$51
  ]))
}

script$51.render = render$51;
script$51.__file = "lib/components/Icons/Solid/SViewGrid.vue";

var script$52 = defineComponent({
  name: 'SQrcode'
});

const _hoisted_1$52 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$52 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$u = /*#__PURE__*/createVNode("path", { d: "M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z" }, null, -1 /* HOISTED */);

function render$52(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$52, [
    _hoisted_2$52,
    _hoisted_3$u
  ]))
}

script$52.render = render$52;
script$52.__file = "lib/components/Icons/Solid/SQrcode.vue";

var script$53 = defineComponent({
  name: 'SLogout'
});

const _hoisted_1$53 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$53 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$53(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$53, [
    _hoisted_2$53
  ]))
}

script$53.render = render$53;
script$53.__file = "lib/components/Icons/Solid/SLogout.vue";

var script$54 = defineComponent({
  name: 'SDotsHorizontal'
});

const _hoisted_1$54 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$54 = /*#__PURE__*/createVNode("path", { d: "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" }, null, -1 /* HOISTED */);

function render$54(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$54, [
    _hoisted_2$54
  ]))
}

script$54.render = render$54;
script$54.__file = "lib/components/Icons/Solid/SDotsHorizontal.vue";

var script$55 = defineComponent({
  name: 'SCash'
});

const _hoisted_1$55 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$55 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$55(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$55, [
    _hoisted_2$55
  ]))
}

script$55.render = render$55;
script$55.__file = "lib/components/Icons/Solid/SCash.vue";

var script$56 = defineComponent({
  name: 'SChevronRight'
});

const _hoisted_1$56 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$56 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$56(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$56, [
    _hoisted_2$56
  ]))
}

script$56.render = render$56;
script$56.__file = "lib/components/Icons/Solid/SChevronRight.vue";

var script$57 = defineComponent({
  name: 'SStatusOnline'
});

const _hoisted_1$57 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$57 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$57(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$57, [
    _hoisted_2$57
  ]))
}

script$57.render = render$57;
script$57.__file = "lib/components/Icons/Solid/SStatusOnline.vue";

var script$58 = defineComponent({
  name: 'SSelector'
});

const _hoisted_1$58 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$58 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$58(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$58, [
    _hoisted_2$58
  ]))
}

script$58.render = render$58;
script$58.__file = "lib/components/Icons/Solid/SSelector.vue";

var script$59 = defineComponent({
  name: 'SDocument'
});

const _hoisted_1$59 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$59 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$59(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$59, [
    _hoisted_2$59
  ]))
}

script$59.render = render$59;
script$59.__file = "lib/components/Icons/Solid/SDocument.vue";

var script$5a = defineComponent({
  name: 'STrash'
});

const _hoisted_1$5a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5a = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5a, [
    _hoisted_2$5a
  ]))
}

script$5a.render = render$5a;
script$5a.__file = "lib/components/Icons/Solid/STrash.vue";

var script$5b = defineComponent({
  name: 'SDocumentText'
});

const _hoisted_1$5b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5b = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5b, [
    _hoisted_2$5b
  ]))
}

script$5b.render = render$5b;
script$5b.__file = "lib/components/Icons/Solid/SDocumentText.vue";

var script$5c = defineComponent({
  name: 'SCurrencyPound'
});

const _hoisted_1$5c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5c = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-14a3 3 0 00-3 3v2H7a1 1 0 000 2h1v1a1 1 0 01-1 1 1 1 0 100 2h6a1 1 0 100-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 100-2h-1V7a1 1 0 112 0 1 1 0 102 0 3 3 0 00-3-3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5c, [
    _hoisted_2$5c
  ]))
}

script$5c.render = render$5c;
script$5c.__file = "lib/components/Icons/Solid/SCurrencyPound.vue";

var script$5d = defineComponent({
  name: 'SPresentationChartBar'
});

const _hoisted_1$5d = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5d = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5d, [
    _hoisted_2$5d
  ]))
}

script$5d.render = render$5d;
script$5d.__file = "lib/components/Icons/Solid/SPresentationChartBar.vue";

var script$5e = defineComponent({
  name: 'SChatAlt2'
});

const _hoisted_1$5e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5e = /*#__PURE__*/createVNode("path", { d: "M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" }, null, -1 /* HOISTED */);
const _hoisted_3$v = /*#__PURE__*/createVNode("path", { d: "M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" }, null, -1 /* HOISTED */);

function render$5e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5e, [
    _hoisted_2$5e,
    _hoisted_3$v
  ]))
}

script$5e.render = render$5e;
script$5e.__file = "lib/components/Icons/Solid/SChatAlt2.vue";

var script$5f = defineComponent({
  name: 'SPhone'
});

const _hoisted_1$5f = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5f = /*#__PURE__*/createVNode("path", { d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" }, null, -1 /* HOISTED */);

function render$5f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5f, [
    _hoisted_2$5f
  ]))
}

script$5f.render = render$5f;
script$5f.__file = "lib/components/Icons/Solid/SPhone.vue";

var script$5g = defineComponent({
  name: 'SClipboardCheck'
});

const _hoisted_1$5g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5g = /*#__PURE__*/createVNode("path", { d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" }, null, -1 /* HOISTED */);
const _hoisted_3$w = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5g, [
    _hoisted_2$5g,
    _hoisted_3$w
  ]))
}

script$5g.render = render$5g;
script$5g.__file = "lib/components/Icons/Solid/SClipboardCheck.vue";

var script$5h = defineComponent({
  name: 'SDeviceMobile'
});

const _hoisted_1$5h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5h = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5h(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5h, [
    _hoisted_2$5h
  ]))
}

script$5h.render = render$5h;
script$5h.__file = "lib/components/Icons/Solid/SDeviceMobile.vue";

var script$5i = defineComponent({
  name: 'SHome'
});

const _hoisted_1$5i = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5i = /*#__PURE__*/createVNode("path", { d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" }, null, -1 /* HOISTED */);

function render$5i(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5i, [
    _hoisted_2$5i
  ]))
}

script$5i.render = render$5i;
script$5i.__file = "lib/components/Icons/Solid/SHome.vue";

var script$5j = defineComponent({
  name: 'SLibrary'
});

const _hoisted_1$5j = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5j = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5j, [
    _hoisted_2$5j
  ]))
}

script$5j.render = render$5j;
script$5j.__file = "lib/components/Icons/Solid/SLibrary.vue";

var script$5k = defineComponent({
  name: 'SFolderRemove'
});

const _hoisted_1$5k = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5k = /*#__PURE__*/createVNode("path", { d: "M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" }, null, -1 /* HOISTED */);
const _hoisted_3$x = /*#__PURE__*/createVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 11h4"
}, null, -1 /* HOISTED */);

function render$5k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5k, [
    _hoisted_2$5k,
    _hoisted_3$x
  ]))
}

script$5k.render = render$5k;
script$5k.__file = "lib/components/Icons/Solid/SFolderRemove.vue";

var script$5l = defineComponent({
  name: 'SArrowCircleUp'
});

const _hoisted_1$5l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5l = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5l, [
    _hoisted_2$5l
  ]))
}

script$5l.render = render$5l;
script$5l.__file = "lib/components/Icons/Solid/SArrowCircleUp.vue";

var script$5m = defineComponent({
  name: 'SSortAscending'
});

const _hoisted_1$5m = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5m = /*#__PURE__*/createVNode("path", { d: "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z" }, null, -1 /* HOISTED */);

function render$5m(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5m, [
    _hoisted_2$5m
  ]))
}

script$5m.render = render$5m;
script$5m.__file = "lib/components/Icons/Solid/SSortAscending.vue";

var script$5n = defineComponent({
  name: 'SMinusCircle'
});

const _hoisted_1$5n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5n = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5n(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5n, [
    _hoisted_2$5n
  ]))
}

script$5n.render = render$5n;
script$5n.__file = "lib/components/Icons/Solid/SMinusCircle.vue";

var script$5o = defineComponent({
  name: 'SViewGridAdd'
});

const _hoisted_1$5o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5o = /*#__PURE__*/createVNode("path", { d: "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" }, null, -1 /* HOISTED */);

function render$5o(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5o, [
    _hoisted_2$5o
  ]))
}

script$5o.render = render$5o;
script$5o.__file = "lib/components/Icons/Solid/SViewGridAdd.vue";

var script$5p = defineComponent({
  name: 'SArrowsExpand'
});

const _hoisted_1$5p = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 20",
  fill: "currentColor"
};
const _hoisted_2$5p = /*#__PURE__*/createVNode("path", {
  stroke: "#374151",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M3 8V4m0 0h4M3 4l4 4m8 0V4m0 0h-4m4 0l-4 4m-8 4v4m0 0h4m-4 0l4-4m8 4l-4-4m4 4v-4m0 4h-4"
}, null, -1 /* HOISTED */);

function render$5p(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5p, [
    _hoisted_2$5p
  ]))
}

script$5p.render = render$5p;
script$5p.__file = "lib/components/Icons/Solid/SArrowsExpand.vue";

var script$5q = defineComponent({
  name: 'SChevronLeft'
});

const _hoisted_1$5q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5q = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5q, [
    _hoisted_2$5q
  ]))
}

script$5q.render = render$5q;
script$5q.__file = "lib/components/Icons/Solid/SChevronLeft.vue";

var script$5r = defineComponent({
  name: 'STable'
});

const _hoisted_1$5r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5r = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5r(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5r, [
    _hoisted_2$5r
  ]))
}

script$5r.render = render$5r;
script$5r.__file = "lib/components/Icons/Solid/STable.vue";

var script$5s = defineComponent({
  name: 'SBan'
});

const _hoisted_1$5s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5s = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5s, [
    _hoisted_2$5s
  ]))
}

script$5s.render = render$5s;
script$5s.__file = "lib/components/Icons/Solid/SBan.vue";

var script$5t = defineComponent({
  name: 'SDuplicate'
});

const _hoisted_1$5t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5t = /*#__PURE__*/createVNode("path", { d: "M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" }, null, -1 /* HOISTED */);
const _hoisted_3$y = /*#__PURE__*/createVNode("path", { d: "M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" }, null, -1 /* HOISTED */);

function render$5t(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5t, [
    _hoisted_2$5t,
    _hoisted_3$y
  ]))
}

script$5t.render = render$5t;
script$5t.__file = "lib/components/Icons/Solid/SDuplicate.vue";

var script$5u = defineComponent({
  name: 'SPaperClip'
});

const _hoisted_1$5u = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5u = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5u(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5u, [
    _hoisted_2$5u
  ]))
}

script$5u.render = render$5u;
script$5u.__file = "lib/components/Icons/Solid/SPaperClip.vue";

var script$5v = defineComponent({
  name: 'SPuzzle'
});

const _hoisted_1$5v = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5v = /*#__PURE__*/createVNode("path", { d: "M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" }, null, -1 /* HOISTED */);

function render$5v(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5v, [
    _hoisted_2$5v
  ]))
}

script$5v.render = render$5v;
script$5v.__file = "lib/components/Icons/Solid/SPuzzle.vue";

var script$5w = defineComponent({
  name: 'SExternalLink'
});

const _hoisted_1$5w = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5w = /*#__PURE__*/createVNode("path", { d: "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" }, null, -1 /* HOISTED */);
const _hoisted_3$z = /*#__PURE__*/createVNode("path", { d: "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" }, null, -1 /* HOISTED */);

function render$5w(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5w, [
    _hoisted_2$5w,
    _hoisted_3$z
  ]))
}

script$5w.render = render$5w;
script$5w.__file = "lib/components/Icons/Solid/SExternalLink.vue";

var script$5x = defineComponent({
  name: 'SVolumeOff'
});

const _hoisted_1$5x = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5x = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5x(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5x, [
    _hoisted_2$5x
  ]))
}

script$5x.render = render$5x;
script$5x.__file = "lib/components/Icons/Solid/SVolumeOff.vue";

var script$5y = defineComponent({
  name: 'SPaperAirplane'
});

const _hoisted_1$5y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5y = /*#__PURE__*/createVNode("path", { d: "M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" }, null, -1 /* HOISTED */);

function render$5y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5y, [
    _hoisted_2$5y
  ]))
}

script$5y.render = render$5y;
script$5y.__file = "lib/components/Icons/Solid/SPaperAirplane.vue";

var script$5z = defineComponent({
  name: 'SShoppingCart'
});

const _hoisted_1$5z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5z = /*#__PURE__*/createVNode("path", { d: "M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }, null, -1 /* HOISTED */);

function render$5z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5z, [
    _hoisted_2$5z
  ]))
}

script$5z.render = render$5z;
script$5z.__file = "lib/components/Icons/Solid/SShoppingCart.vue";

var script$5A = defineComponent({
  name: 'SChartBar'
});

const _hoisted_1$5A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5A = /*#__PURE__*/createVNode("path", { d: "M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" }, null, -1 /* HOISTED */);

function render$5A(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5A, [
    _hoisted_2$5A
  ]))
}

script$5A.render = render$5A;
script$5A.__file = "lib/components/Icons/Solid/SChartBar.vue";

var script$5B = defineComponent({
  name: 'SStar'
});

const _hoisted_1$5B = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5B = /*#__PURE__*/createVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }, null, -1 /* HOISTED */);

function render$5B(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5B, [
    _hoisted_2$5B
  ]))
}

script$5B.render = render$5B;
script$5B.__file = "lib/components/Icons/Solid/SStar.vue";

var script$5C = defineComponent({
  name: 'SDocumentDuplicate'
});

const _hoisted_1$5C = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5C = /*#__PURE__*/createVNode("path", { d: "M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" }, null, -1 /* HOISTED */);
const _hoisted_3$A = /*#__PURE__*/createVNode("path", { d: "M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" }, null, -1 /* HOISTED */);

function render$5C(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5C, [
    _hoisted_2$5C,
    _hoisted_3$A
  ]))
}

script$5C.render = render$5C;
script$5C.__file = "lib/components/Icons/Solid/SDocumentDuplicate.vue";

var script$5D = defineComponent({
  name: 'SUserGroup'
});

const _hoisted_1$5D = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5D = /*#__PURE__*/createVNode("path", { d: "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" }, null, -1 /* HOISTED */);

function render$5D(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5D, [
    _hoisted_2$5D
  ]))
}

script$5D.render = render$5D;
script$5D.__file = "lib/components/Icons/Solid/SUserGroup.vue";

var script$5E = defineComponent({
  name: 'SChevronDown'
});

const _hoisted_1$5E = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5E = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5E(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5E, [
    _hoisted_2$5E
  ]))
}

script$5E.render = render$5E;
script$5E.__file = "lib/components/Icons/Solid/SChevronDown.vue";

var script$5F = defineComponent({
  name: 'SChartPie'
});

const _hoisted_1$5F = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5F = /*#__PURE__*/createVNode("path", { d: "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" }, null, -1 /* HOISTED */);
const _hoisted_3$B = /*#__PURE__*/createVNode("path", { d: "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" }, null, -1 /* HOISTED */);

function render$5F(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5F, [
    _hoisted_2$5F,
    _hoisted_3$B
  ]))
}

script$5F.render = render$5F;
script$5F.__file = "lib/components/Icons/Solid/SChartPie.vue";

var script$5G = defineComponent({
  name: 'SUsers'
});

const _hoisted_1$5G = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5G = /*#__PURE__*/createVNode("path", { d: "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" }, null, -1 /* HOISTED */);

function render$5G(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5G, [
    _hoisted_2$5G
  ]))
}

script$5G.render = render$5G;
script$5G.__file = "lib/components/Icons/Solid/SUsers.vue";

var script$5H = defineComponent({
  name: 'SCubeTransparent'
});

const _hoisted_1$5H = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5H = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.504 1.132a1 1 0 01.992 0l1.75 1a1 1 0 11-.992 1.736L10 3.152l-1.254.716a1 1 0 11-.992-1.736l1.75-1zM5.618 4.504a1 1 0 01-.372 1.364L5.016 6l.23.132a1 1 0 11-.992 1.736L4 7.723V8a1 1 0 01-2 0V6a.996.996 0 01.52-.878l1.734-.99a1 1 0 011.364.372zm8.764 0a1 1 0 011.364-.372l1.733.99A1.002 1.002 0 0118 6v2a1 1 0 11-2 0v-.277l-.254.145a1 1 0 11-.992-1.736l.23-.132-.23-.132a1 1 0 01-.372-1.364zm-7 4a1 1 0 011.364-.372L10 8.848l1.254-.716a1 1 0 11.992 1.736L11 10.58V12a1 1 0 11-2 0v-1.42l-1.246-.712a1 1 0 01-.372-1.364zM3 11a1 1 0 011 1v1.42l1.246.712a1 1 0 11-.992 1.736l-1.75-1A1 1 0 012 14v-2a1 1 0 011-1zm14 0a1 1 0 011 1v2a1 1 0 01-.504.868l-1.75 1a1 1 0 11-.992-1.736L16 13.42V12a1 1 0 011-1zm-9.618 5.504a1 1 0 011.364-.372l.254.145V16a1 1 0 112 0v.277l.254-.145a1 1 0 11.992 1.736l-1.735.992a.995.995 0 01-1.022 0l-1.735-.992a1 1 0 01-.372-1.364z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5H(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5H, [
    _hoisted_2$5H
  ]))
}

script$5H.render = render$5H;
script$5H.__file = "lib/components/Icons/Solid/SCubeTransparent.vue";

var script$5I = defineComponent({
  name: 'SShoppingBag'
});

const _hoisted_1$5I = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5I = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5I, [
    _hoisted_2$5I
  ]))
}

script$5I.render = render$5I;
script$5I.__file = "lib/components/Icons/Solid/SShoppingBag.vue";

var script$5J = defineComponent({
  name: 'SBeaker'
});

const _hoisted_1$5J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5J = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.114-.035l1.063-1.063A3 3 0 009 8.172z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5J(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5J, [
    _hoisted_2$5J
  ]))
}

script$5J.render = render$5J;
script$5J.__file = "lib/components/Icons/Solid/SBeaker.vue";

var script$5K = defineComponent({
  name: 'SCheckCircle'
});

const _hoisted_1$5K = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5K = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5K(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5K, [
    _hoisted_2$5K
  ]))
}

script$5K.render = render$5K;
script$5K.__file = "lib/components/Icons/Solid/SCheckCircle.vue";

var script$5L = defineComponent({
  name: 'SPhoneOutgoing'
});

const _hoisted_1$5L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5L = /*#__PURE__*/createVNode("path", { d: "M17.924 2.617a.997.997 0 00-.215-.322l-.004-.004A.997.997 0 0017 2h-4a1 1 0 100 2h1.586l-3.293 3.293a1 1 0 001.414 1.414L16 5.414V7a1 1 0 102 0V3a.997.997 0 00-.076-.383z" }, null, -1 /* HOISTED */);
const _hoisted_3$C = /*#__PURE__*/createVNode("path", { d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" }, null, -1 /* HOISTED */);

function render$5L(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5L, [
    _hoisted_2$5L,
    _hoisted_3$C
  ]))
}

script$5L.render = render$5L;
script$5L.__file = "lib/components/Icons/Solid/SPhoneOutgoing.vue";

var script$5M = defineComponent({
  name: 'STranslate'
});

const _hoisted_1$5M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5M = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 11.236 11.618 14z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5M(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5M, [
    _hoisted_2$5M
  ]))
}

script$5M.render = render$5M;
script$5M.__file = "lib/components/Icons/Solid/STranslate.vue";

var script$5N = defineComponent({
  name: 'SPencilAlt'
});

const _hoisted_1$5N = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5N = /*#__PURE__*/createVNode("path", { d: "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" }, null, -1 /* HOISTED */);
const _hoisted_3$D = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5N(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5N, [
    _hoisted_2$5N,
    _hoisted_3$D
  ]))
}

script$5N.render = render$5N;
script$5N.__file = "lib/components/Icons/Solid/SPencilAlt.vue";

var script$5O = defineComponent({
  name: 'SArrowRight'
});

const _hoisted_1$5O = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5O = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5O(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5O, [
    _hoisted_2$5O
  ]))
}

script$5O.render = render$5O;
script$5O.__file = "lib/components/Icons/Solid/SArrowRight.vue";

var script$5P = defineComponent({
  name: 'SSun'
});

const _hoisted_1$5P = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5P = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5P(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5P, [
    _hoisted_2$5P
  ]))
}

script$5P.render = render$5P;
script$5P.__file = "lib/components/Icons/Solid/SSun.vue";

var script$5Q = defineComponent({
  name: 'SLogin'
});

const _hoisted_1$5Q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5Q = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5Q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5Q, [
    _hoisted_2$5Q
  ]))
}

script$5Q.render = render$5Q;
script$5Q.__file = "lib/components/Icons/Solid/SLogin.vue";

var script$5R = defineComponent({
  name: 'SZoomIn'
});

const _hoisted_1$5R = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5R = /*#__PURE__*/createVNode("path", { d: "M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z" }, null, -1 /* HOISTED */);
const _hoisted_3$E = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5R(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5R, [
    _hoisted_2$5R,
    _hoisted_3$E
  ]))
}

script$5R.render = render$5R;
script$5R.__file = "lib/components/Icons/Solid/SZoomIn.vue";

var script$5S = defineComponent({
  name: 'SUpload'
});

const _hoisted_1$5S = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5S = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5S(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5S, [
    _hoisted_2$5S
  ]))
}

script$5S.render = render$5S;
script$5S.__file = "lib/components/Icons/Solid/SUpload.vue";

var script$5T = defineComponent({
  name: 'SScissors'
});

const _hoisted_1$5T = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5T = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.5 2a3.5 3.5 0 101.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 101.414 1.414l8.128-8.127a1 1 0 00-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 005.5 2zM4 5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$F = /*#__PURE__*/createVNode("path", { d: "M12.828 11.414a1 1 0 00-1.414 1.414l3.879 3.88a1 1 0 001.414-1.415l-3.879-3.879z" }, null, -1 /* HOISTED */);

function render$5T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5T, [
    _hoisted_2$5T,
    _hoisted_3$F
  ]))
}

script$5T.render = render$5T;
script$5T.__file = "lib/components/Icons/Solid/SScissors.vue";

var script$5U = defineComponent({
  name: 'SChevronDoubleLeft'
});

const _hoisted_1$5U = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5U = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5U(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5U, [
    _hoisted_2$5U
  ]))
}

script$5U.render = render$5U;
script$5U.__file = "lib/components/Icons/Solid/SChevronDoubleLeft.vue";

var script$5V = defineComponent({
  name: 'SChevronDoubleRight'
});

const _hoisted_1$5V = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5V = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$G = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5V(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5V, [
    _hoisted_2$5V,
    _hoisted_3$G
  ]))
}

script$5V.render = render$5V;
script$5V.__file = "lib/components/Icons/Solid/SChevronDoubleRight.vue";

var script$5W = defineComponent({
  name: 'SGlobeAlt'
});

const _hoisted_1$5W = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5W = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5W(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5W, [
    _hoisted_2$5W
  ]))
}

script$5W.render = render$5W;
script$5W.__file = "lib/components/Icons/Solid/SGlobeAlt.vue";

var script$5X = defineComponent({
  name: 'SLockClosed'
});

const _hoisted_1$5X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5X = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5X(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5X, [
    _hoisted_2$5X
  ]))
}

script$5X.render = render$5X;
script$5X.__file = "lib/components/Icons/Solid/SLockClosed.vue";

var script$5Y = defineComponent({
  name: 'SSupport'
});

const _hoisted_1$5Y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5Y = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5Y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5Y, [
    _hoisted_2$5Y
  ]))
}

script$5Y.render = render$5Y;
script$5Y.__file = "lib/components/Icons/Solid/SSupport.vue";

var script$5Z = defineComponent({
  name: 'SShieldCheck'
});

const _hoisted_1$5Z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5Z = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5Z, [
    _hoisted_2$5Z
  ]))
}

script$5Z.render = render$5Z;
script$5Z.__file = "lib/components/Icons/Solid/SShieldCheck.vue";

var script$5_ = defineComponent({
  name: 'SCloudDownload'
});

const _hoisted_1$5_ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5_ = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 9.5A3.5 3.5 0 005.5 13H9v2.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 10-.616-8.958 4.002 4.002 0 10-7.753 1.977A3.5 3.5 0 002 9.5zm9 3.5H9V8a1 1 0 012 0v5z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5_(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5_, [
    _hoisted_2$5_
  ]))
}

script$5_.render = render$5_;
script$5_.__file = "lib/components/Icons/Solid/SCloudDownload.vue";

var script$5$ = defineComponent({
  name: 'SShieldExclamation'
});

const _hoisted_1$5$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$5$ = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11 14a1 1 0 11-2 0 1 1 0 012 0zm0-7a1 1 0 10-2 0v3a1 1 0 102 0V7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$5$(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$5$, [
    _hoisted_2$5$
  ]))
}

script$5$.render = render$5$;
script$5$.__file = "lib/components/Icons/Solid/SShieldExclamation.vue";

var script$60 = defineComponent({
  name: 'SIdentification'
});

const _hoisted_1$60 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$60 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$60(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$60, [
    _hoisted_2$60
  ]))
}

script$60.render = render$60;
script$60.__file = "lib/components/Icons/Solid/SIdentification.vue";

var script$61 = defineComponent({
  name: 'SClipboardList'
});

const _hoisted_1$61 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$61 = /*#__PURE__*/createVNode("path", { d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" }, null, -1 /* HOISTED */);
const _hoisted_3$H = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$61(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$61, [
    _hoisted_2$61,
    _hoisted_3$H
  ]))
}

script$61.render = render$61;
script$61.__file = "lib/components/Icons/Solid/SClipboardList.vue";

var script$62 = defineComponent({
  name: 'SCloud'
});

const _hoisted_1$62 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$62 = /*#__PURE__*/createVNode("path", { d: "M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z" }, null, -1 /* HOISTED */);

function render$62(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$62, [
    _hoisted_2$62
  ]))
}

script$62.render = render$62;
script$62.__file = "lib/components/Icons/Solid/SCloud.vue";

var script$63 = defineComponent({
  name: 'SSparkles'
});

const _hoisted_1$63 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$63 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$63(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$63, [
    _hoisted_2$63
  ]))
}

script$63.render = render$63;
script$63.__file = "lib/components/Icons/Solid/SSparkles.vue";

var script$64 = defineComponent({
  name: 'SExclamationCircle'
});

const _hoisted_1$64 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$64 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$64(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$64, [
    _hoisted_2$64
  ]))
}

script$64.render = render$64;
script$64.__file = "lib/components/Icons/Solid/SExclamationCircle.vue";

var script$65 = defineComponent({
  name: 'SBadgeCheck'
});

const _hoisted_1$65 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$65 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$65(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$65, [
    _hoisted_2$65
  ]))
}

script$65.render = render$65;
script$65.__file = "lib/components/Icons/Solid/SBadgeCheck.vue";

var script$66 = defineComponent({
  name: 'SFastForward'
});

const _hoisted_1$66 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$66 = /*#__PURE__*/createVNode("path", { d: "M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z" }, null, -1 /* HOISTED */);

function render$66(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$66, [
    _hoisted_2$66
  ]))
}

script$66.render = render$66;
script$66.__file = "lib/components/Icons/Solid/SFastForward.vue";

var script$67 = defineComponent({
  name: 'SFire'
});

const _hoisted_1$67 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$67 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$67(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$67, [
    _hoisted_2$67
  ]))
}

script$67.render = render$67;
script$67.__file = "lib/components/Icons/Solid/SFire.vue";

var script$68 = defineComponent({
  name: 'SClipboard'
});

const _hoisted_1$68 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$68 = /*#__PURE__*/createVNode("path", { d: "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" }, null, -1 /* HOISTED */);
const _hoisted_3$I = /*#__PURE__*/createVNode("path", { d: "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" }, null, -1 /* HOISTED */);

function render$68(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$68, [
    _hoisted_2$68,
    _hoisted_3$I
  ]))
}

script$68.render = render$68;
script$68.__file = "lib/components/Icons/Solid/SClipboard.vue";

var script$69 = defineComponent({
  name: 'SBookOpen'
});

const _hoisted_1$69 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$69 = /*#__PURE__*/createVNode("path", { d: "M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" }, null, -1 /* HOISTED */);

function render$69(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$69, [
    _hoisted_2$69
  ]))
}

script$69.render = render$69;
script$69.__file = "lib/components/Icons/Solid/SBookOpen.vue";

var script$6a = defineComponent({
  name: 'SDocumentAdd'
});

const _hoisted_1$6a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6a = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6a, [
    _hoisted_2$6a
  ]))
}

script$6a.render = render$6a;
script$6a.__file = "lib/components/Icons/Solid/SDocumentAdd.vue";

var script$6b = defineComponent({
  name: 'SMenuAlt3'
});

const _hoisted_1$6b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6b = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6b, [
    _hoisted_2$6b
  ]))
}

script$6b.render = render$6b;
script$6b.__file = "lib/components/Icons/Solid/SMenuAlt3.vue";

var script$6c = defineComponent({
  name: 'SLightBulb'
});

const _hoisted_1$6c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6c = /*#__PURE__*/createVNode("path", { d: "M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" }, null, -1 /* HOISTED */);

function render$6c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6c, [
    _hoisted_2$6c
  ]))
}

script$6c.render = render$6c;
script$6c.__file = "lib/components/Icons/Solid/SLightBulb.vue";

var script$6d = defineComponent({
  name: 'SRefresh'
});

const _hoisted_1$6d = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6d = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6d, [
    _hoisted_2$6d
  ]))
}

script$6d.render = render$6d;
script$6d.__file = "lib/components/Icons/Solid/SRefresh.vue";

var script$6e = defineComponent({
  name: 'SAnnotation'
});

const _hoisted_1$6e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6e = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6e, [
    _hoisted_2$6e
  ]))
}

script$6e.render = render$6e;
script$6e.__file = "lib/components/Icons/Solid/SAnnotation.vue";

var script$6f = defineComponent({
  name: 'SFolderOpen'
});

const _hoisted_1$6f = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6f = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$J = /*#__PURE__*/createVNode("path", { d: "M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z" }, null, -1 /* HOISTED */);

function render$6f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6f, [
    _hoisted_2$6f,
    _hoisted_3$J
  ]))
}

script$6f.render = render$6f;
script$6f.__file = "lib/components/Icons/Solid/SFolderOpen.vue";

var script$6g = defineComponent({
  name: 'SDotsCircleHorizontal'
});

const _hoisted_1$6g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6g = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6g, [
    _hoisted_2$6g
  ]))
}

script$6g.render = render$6g;
script$6g.__file = "lib/components/Icons/Solid/SDotsCircleHorizontal.vue";

var script$6h = defineComponent({
  name: 'STerminal'
});

const _hoisted_1$6h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6h = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6h(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6h, [
    _hoisted_2$6h
  ]))
}

script$6h.render = render$6h;
script$6h.__file = "lib/components/Icons/Solid/STerminal.vue";

var script$6i = defineComponent({
  name: 'SUser'
});

const _hoisted_1$6i = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6i = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6i(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6i, [
    _hoisted_2$6i
  ]))
}

script$6i.render = render$6i;
script$6i.__file = "lib/components/Icons/Solid/SUser.vue";

var script$6j = defineComponent({
  name: 'SPhoneIncoming'
});

const _hoisted_1$6j = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6j = /*#__PURE__*/createVNode("path", { d: "M14.414 7l3.293-3.293a1 1 0 00-1.414-1.414L13 5.586V4a1 1 0 10-2 0v4.003a.996.996 0 00.617.921A.997.997 0 0012 9h4a1 1 0 100-2h-1.586z" }, null, -1 /* HOISTED */);
const _hoisted_3$K = /*#__PURE__*/createVNode("path", { d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" }, null, -1 /* HOISTED */);

function render$6j(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6j, [
    _hoisted_2$6j,
    _hoisted_3$K
  ]))
}

script$6j.render = render$6j;
script$6j.__file = "lib/components/Icons/Solid/SPhoneIncoming.vue";

var script$6k = defineComponent({
  name: 'SUserRemove'
});

const _hoisted_1$6k = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6k = /*#__PURE__*/createVNode("path", { d: "M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z" }, null, -1 /* HOISTED */);

function render$6k(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6k, [
    _hoisted_2$6k
  ]))
}

script$6k.render = render$6k;
script$6k.__file = "lib/components/Icons/Solid/SUserRemove.vue";

var script$6l = defineComponent({
  name: 'SBookmark'
});

const _hoisted_1$6l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6l = /*#__PURE__*/createVNode("path", { d: "M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z" }, null, -1 /* HOISTED */);

function render$6l(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6l, [
    _hoisted_2$6l
  ]))
}

script$6l.render = render$6l;
script$6l.__file = "lib/components/Icons/Solid/SBookmark.vue";

var script$6m = defineComponent({
  name: 'SX'
});

const _hoisted_1$6m = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6m = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6m(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6m, [
    _hoisted_2$6m
  ]))
}

script$6m.render = render$6m;
script$6m.__file = "lib/components/Icons/Solid/SX.vue";

var script$6n = defineComponent({
  name: 'SCog'
});

const _hoisted_1$6n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6n = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6n(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6n, [
    _hoisted_2$6n
  ]))
}

script$6n.render = render$6n;
script$6n.__file = "lib/components/Icons/Solid/SCog.vue";

var script$6o = defineComponent({
  name: 'SThumbUp'
});

const _hoisted_1$6o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6o = /*#__PURE__*/createVNode("path", { d: "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" }, null, -1 /* HOISTED */);

function render$6o(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6o, [
    _hoisted_2$6o
  ]))
}

script$6o.render = render$6o;
script$6o.__file = "lib/components/Icons/Solid/SThumbUp.vue";

var script$6p = defineComponent({
  name: 'SCurrencyBangladeshi'
});

const _hoisted_1$6p = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6p = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 4a1 1 0 000 2 1 1 0 011 1v1H7a1 1 0 000 2h1v3a3 3 0 106 0v-1a1 1 0 10-2 0v1a1 1 0 11-2 0v-3h3a1 1 0 100-2h-3V7a3 3 0 00-3-3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6p(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6p, [
    _hoisted_2$6p
  ]))
}

script$6p.render = render$6p;
script$6p.__file = "lib/components/Icons/Solid/SCurrencyBangladeshi.vue";

var script$6q = defineComponent({
  name: 'SVariable'
});

const _hoisted_1$6q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6q = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.649 3.084A1 1 0 015.163 4.4 13.95 13.95 0 004 10c0 1.993.416 3.886 1.164 5.6a1 1 0 01-1.832.8A15.95 15.95 0 012 10c0-2.274.475-4.44 1.332-6.4a1 1 0 011.317-.516zM12.96 7a3 3 0 00-2.342 1.126l-.328.41-.111-.279A2 2 0 008.323 7H8a1 1 0 000 2h.323l.532 1.33-1.035 1.295a1 1 0 01-.781.375H7a1 1 0 100 2h.039a3 3 0 002.342-1.126l.328-.41.111.279A2 2 0 0011.677 14H12a1 1 0 100-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0112.961 9H13a1 1 0 100-2h-.039zm1.874-2.6a1 1 0 011.833-.8A15.95 15.95 0 0118 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 11-1.832-.8A13.949 13.949 0 0016 10c0-1.993-.416-3.886-1.165-5.6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6q, [
    _hoisted_2$6q
  ]))
}

script$6q.render = render$6q;
script$6q.__file = "lib/components/Icons/Solid/SVariable.vue";

var script$6r = defineComponent({
  name: 'SUserCircle'
});

const _hoisted_1$6r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6r = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6r(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6r, [
    _hoisted_2$6r
  ]))
}

script$6r.render = render$6r;
script$6r.__file = "lib/components/Icons/Solid/SUserCircle.vue";

var script$6s = defineComponent({
  name: 'SArrowNarrowLeft'
});

const _hoisted_1$6s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6s = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6s(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6s, [
    _hoisted_2$6s
  ]))
}

script$6s.render = render$6s;
script$6s.__file = "lib/components/Icons/Solid/SArrowNarrowLeft.vue";

var script$6t = defineComponent({
  name: 'SShare'
});

const _hoisted_1$6t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6t = /*#__PURE__*/createVNode("path", { d: "M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" }, null, -1 /* HOISTED */);

function render$6t(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6t, [
    _hoisted_2$6t
  ]))
}

script$6t.render = render$6t;
script$6t.__file = "lib/components/Icons/Solid/SShare.vue";

var script$6u = defineComponent({
  name: 'SFolder'
});

const _hoisted_1$6u = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6u = /*#__PURE__*/createVNode("path", { d: "M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" }, null, -1 /* HOISTED */);

function render$6u(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6u, [
    _hoisted_2$6u
  ]))
}

script$6u.render = render$6u;
script$6u.__file = "lib/components/Icons/Solid/SFolder.vue";

var script$6v = defineComponent({
  name: 'SArrowNarrowRight'
});

const _hoisted_1$6v = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6v = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6v(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6v, [
    _hoisted_2$6v
  ]))
}

script$6v.render = render$6v;
script$6v.__file = "lib/components/Icons/Solid/SArrowNarrowRight.vue";

var script$6w = defineComponent({
  name: 'SDownload'
});

const _hoisted_1$6w = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6w = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6w(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6w, [
    _hoisted_2$6w
  ]))
}

script$6w.render = render$6w;
script$6w.__file = "lib/components/Icons/Solid/SDownload.vue";

var script$6x = defineComponent({
  name: 'SHand'
});

const _hoisted_1$6x = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6x = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6x(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6x, [
    _hoisted_2$6x
  ]))
}

script$6x.render = render$6x;
script$6x.__file = "lib/components/Icons/Solid/SHand.vue";

var script$6y = defineComponent({
  name: 'SMenu'
});

const _hoisted_1$6y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6y = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6y, [
    _hoisted_2$6y
  ]))
}

script$6y.render = render$6y;
script$6y.__file = "lib/components/Icons/Solid/SMenu.vue";

var script$6z = defineComponent({
  name: 'SBackspace'
});

const _hoisted_1$6z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6z = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.707 4.879A3 3 0 018.828 4H15a3 3 0 013 3v6a3 3 0 01-3 3H8.828a3 3 0 01-2.12-.879l-4.415-4.414a1 1 0 010-1.414l4.414-4.414zm4 2.414a1 1 0 00-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 101.414 1.414L12 11.414l1.293 1.293a1 1 0 001.414-1.414L13.414 10l1.293-1.293a1 1 0 00-1.414-1.414L12 8.586l-1.293-1.293z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6z, [
    _hoisted_2$6z
  ]))
}

script$6z.render = render$6z;
script$6z.__file = "lib/components/Icons/Solid/SBackspace.vue";

var script$6A = defineComponent({
  name: 'SVolumeUp'
});

const _hoisted_1$6A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6A = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6A(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6A, [
    _hoisted_2$6A
  ]))
}

script$6A.render = render$6A;
script$6A.__file = "lib/components/Icons/Solid/SVolumeUp.vue";

var script$6B = defineComponent({
  name: 'SInboxIn'
});

const _hoisted_1$6B = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6B = /*#__PURE__*/createVNode("path", { d: "M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z" }, null, -1 /* HOISTED */);
const _hoisted_3$L = /*#__PURE__*/createVNode("path", { d: "M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z" }, null, -1 /* HOISTED */);

function render$6B(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6B, [
    _hoisted_2$6B,
    _hoisted_3$L
  ]))
}

script$6B.render = render$6B;
script$6B.__file = "lib/components/Icons/Solid/SInboxIn.vue";

var script$6C = defineComponent({
  name: 'SInbox'
});

const _hoisted_1$6C = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6C = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6C(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6C, [
    _hoisted_2$6C
  ]))
}

script$6C.render = render$6C;
script$6C.__file = "lib/components/Icons/Solid/SInbox.vue";

var script$6D = defineComponent({
  name: 'SEmojiSad'
});

const _hoisted_1$6D = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6D = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6D(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6D, [
    _hoisted_2$6D
  ]))
}

script$6D.render = render$6D;
script$6D.__file = "lib/components/Icons/Solid/SEmojiSad.vue";

var script$6E = defineComponent({
  name: 'SExclamation'
});

const _hoisted_1$6E = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6E = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6E(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6E, [
    _hoisted_2$6E
  ]))
}

script$6E.render = render$6E;
script$6E.__file = "lib/components/Icons/Solid/SExclamation.vue";

var script$6F = defineComponent({
  name: 'SChat'
});

const _hoisted_1$6F = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6F = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6F(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6F, [
    _hoisted_2$6F
  ]))
}

script$6F.render = render$6F;
script$6F.__file = "lib/components/Icons/Solid/SChat.vue";

var script$6G = defineComponent({
  name: 'SBookmarkAlt'
});

const _hoisted_1$6G = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6G = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6G(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6G, [
    _hoisted_2$6G
  ]))
}

script$6G.render = render$6G;
script$6G.__file = "lib/components/Icons/Solid/SBookmarkAlt.vue";

var script$6H = defineComponent({
  name: 'SCake'
});

const _hoisted_1$6H = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6H = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 3a1 1 0 011-1h.01a1 1 0 010 2H7a1 1 0 01-1-1zm2 3a1 1 0 00-2 0v1a2 2 0 00-2 2v1a2 2 0 00-2 2v.683a3.7 3.7 0 011.055.485 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0A3.7 3.7 0 0118 12.683V12a2 2 0 00-2-2V9a2 2 0 00-2-2V6a1 1 0 10-2 0v1h-1V6a1 1 0 10-2 0v1H8V6zm10 8.868a3.704 3.704 0 01-4.055-.036 1.704 1.704 0 00-1.89 0 3.704 3.704 0 01-4.11 0 1.704 1.704 0 00-1.89 0A3.704 3.704 0 012 14.868V17a1 1 0 001 1h14a1 1 0 001-1v-2.132zM9 3a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm3 0a1 1 0 011-1h.01a1 1 0 110 2H13a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6H(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6H, [
    _hoisted_2$6H
  ]))
}

script$6H.render = render$6H;
script$6H.__file = "lib/components/Icons/Solid/SCake.vue";

var script$6I = defineComponent({
  name: 'SChevronUp'
});

const _hoisted_1$6I = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6I = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6I(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6I, [
    _hoisted_2$6I
  ]))
}

script$6I.render = render$6I;
script$6I.__file = "lib/components/Icons/Solid/SChevronUp.vue";

var script$6J = defineComponent({
  name: 'SQuestionMarkCircle'
});

const _hoisted_1$6J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6J = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6J(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6J, [
    _hoisted_2$6J
  ]))
}

script$6J.render = render$6J;
script$6J.__file = "lib/components/Icons/Solid/SQuestionMarkCircle.vue";

var script$6K = defineComponent({
  name: 'SMinusSm'
});

const _hoisted_1$6K = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6K = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6K(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6K, [
    _hoisted_2$6K
  ]))
}

script$6K.render = render$6K;
script$6K.__file = "lib/components/Icons/Solid/SMinusSm.vue";

var script$6L = defineComponent({
  name: 'SThumbDown'
});

const _hoisted_1$6L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6L = /*#__PURE__*/createVNode("path", { d: "M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z" }, null, -1 /* HOISTED */);

function render$6L(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6L, [
    _hoisted_2$6L
  ]))
}

script$6L.render = render$6L;
script$6L.__file = "lib/components/Icons/Solid/SThumbDown.vue";

var script$6M = defineComponent({
  name: 'SZoomOut'
});

const _hoisted_1$6M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6M = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$M = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 8a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6M(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6M, [
    _hoisted_2$6M,
    _hoisted_3$M
  ]))
}

script$6M.render = render$6M;
script$6M.__file = "lib/components/Icons/Solid/SZoomOut.vue";

var script$6N = defineComponent({
  name: 'SArrowLeft'
});

const _hoisted_1$6N = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6N = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6N(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6N, [
    _hoisted_2$6N
  ]))
}

script$6N.render = render$6N;
script$6N.__file = "lib/components/Icons/Solid/SArrowLeft.vue";

var script$6O = defineComponent({
  name: 'SCursorClick'
});

const _hoisted_1$6O = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6O = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6O(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6O, [
    _hoisted_2$6O
  ]))
}

script$6O.render = render$6O;
script$6O.__file = "lib/components/Icons/Solid/SCursorClick.vue";

var script$6P = defineComponent({
  name: 'SDocumentRemove'
});

const _hoisted_1$6P = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6P = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm1 8a1 1 0 100 2h6a1 1 0 100-2H7z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6P(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6P, [
    _hoisted_2$6P
  ]))
}

script$6P.render = render$6P;
script$6P.__file = "lib/components/Icons/Solid/SDocumentRemove.vue";

var script$6Q = defineComponent({
  name: 'STrendingDown'
});

const _hoisted_1$6Q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6Q = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6Q(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6Q, [
    _hoisted_2$6Q
  ]))
}

script$6Q.render = render$6Q;
script$6Q.__file = "lib/components/Icons/Solid/STrendingDown.vue";

var script$6R = defineComponent({
  name: 'SSaveAs'
});

const _hoisted_1$6R = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6R = /*#__PURE__*/createVNode("path", { d: "M9.707 7.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L13 8.586V5h3a2 2 0 012 2v5a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2h3v3.586L9.707 7.293zM11 3a1 1 0 112 0v2h-2V3z" }, null, -1 /* HOISTED */);
const _hoisted_3$N = /*#__PURE__*/createVNode("path", { d: "M4 9a2 2 0 00-2 2v5a2 2 0 002 2h8a2 2 0 002-2H4V9z" }, null, -1 /* HOISTED */);

function render$6R(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6R, [
    _hoisted_2$6R,
    _hoisted_3$N
  ]))
}

script$6R.render = render$6R;
script$6R.__file = "lib/components/Icons/Solid/SSaveAs.vue";

var script$6S = defineComponent({
  name: 'SClipboardCopy'
});

const _hoisted_1$6S = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6S = /*#__PURE__*/createVNode("path", { d: "M8 2a1 1 0 000 2h2a1 1 0 100-2H8z" }, null, -1 /* HOISTED */);
const _hoisted_3$O = /*#__PURE__*/createVNode("path", { d: "M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z" }, null, -1 /* HOISTED */);

function render$6S(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6S, [
    _hoisted_2$6S,
    _hoisted_3$O
  ]))
}

script$6S.render = render$6S;
script$6S.__file = "lib/components/Icons/Solid/SClipboardCopy.vue";

var script$6T = defineComponent({
  name: 'SDotsVertical'
});

const _hoisted_1$6T = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6T = /*#__PURE__*/createVNode("path", { d: "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" }, null, -1 /* HOISTED */);

function render$6T(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6T, [
    _hoisted_2$6T
  ]))
}

script$6T.render = render$6T;
script$6T.__file = "lib/components/Icons/Solid/SDotsVertical.vue";

var script$6U = defineComponent({
  name: 'SBell'
});

const _hoisted_1$6U = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6U = /*#__PURE__*/createVNode("path", { d: "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" }, null, -1 /* HOISTED */);

function render$6U(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6U, [
    _hoisted_2$6U
  ]))
}

script$6U.render = render$6U;
script$6U.__file = "lib/components/Icons/Solid/SBell.vue";

var script$6V = defineComponent({
  name: 'SXCircle'
});

const _hoisted_1$6V = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6V = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6V(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6V, [
    _hoisted_2$6V
  ]))
}

script$6V.render = render$6V;
script$6V.__file = "lib/components/Icons/Solid/SXCircle.vue";

var script$6W = defineComponent({
  name: 'SLightningBolt'
});

const _hoisted_1$6W = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6W = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6W(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6W, [
    _hoisted_2$6W
  ]))
}

script$6W.render = render$6W;
script$6W.__file = "lib/components/Icons/Solid/SLightningBolt.vue";

var script$6X = defineComponent({
  name: 'SGlobe'
});

const _hoisted_1$6X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6X = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6X(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6X, [
    _hoisted_2$6X
  ]))
}

script$6X.render = render$6X;
script$6X.__file = "lib/components/Icons/Solid/SGlobe.vue";

var script$6Y = defineComponent({
  name: 'SArrowUp'
});

const _hoisted_1$6Y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6Y = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6Y(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6Y, [
    _hoisted_2$6Y
  ]))
}

script$6Y.render = render$6Y;
script$6Y.__file = "lib/components/Icons/Solid/SArrowUp.vue";

var script$6Z = defineComponent({
  name: 'SInformationCircle'
});

const _hoisted_1$6Z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6Z = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6Z(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6Z, [
    _hoisted_2$6Z
  ]))
}

script$6Z.render = render$6Z;
script$6Z.__file = "lib/components/Icons/Solid/SInformationCircle.vue";

var script$6_ = defineComponent({
  name: 'SCheck'
});

const _hoisted_1$6_ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6_ = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$6_(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6_, [
    _hoisted_2$6_
  ]))
}

script$6_.render = render$6_;
script$6_.__file = "lib/components/Icons/Solid/SCheck.vue";

var script$6$ = defineComponent({
  name: 'STicket'
});

const _hoisted_1$6$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$6$ = /*#__PURE__*/createVNode("path", { d: "M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z" }, null, -1 /* HOISTED */);

function render$6$(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$6$, [
    _hoisted_2$6$
  ]))
}

script$6$.render = render$6$;
script$6$.__file = "lib/components/Icons/Solid/STicket.vue";

var script$70 = defineComponent({
  name: 'SSwitchHorizontal'
});

const _hoisted_1$70 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$70 = /*#__PURE__*/createVNode("path", { d: "M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" }, null, -1 /* HOISTED */);

function render$70(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$70, [
    _hoisted_2$70
  ]))
}

script$70.render = render$70;
script$70.__file = "lib/components/Icons/Solid/SSwitchHorizontal.vue";

var script$71 = defineComponent({
  name: 'SPlus'
});

const _hoisted_1$71 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$71 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$71(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$71, [
    _hoisted_2$71
  ]))
}

script$71.render = render$71;
script$71.__file = "lib/components/Icons/Solid/SPlus.vue";

var script$72 = defineComponent({
  name: 'SMailOpen'
});

const _hoisted_1$72 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$72 = /*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);

function render$72(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$72, [
    _hoisted_2$72
  ]))
}

script$72.render = render$72;
script$72.__file = "lib/components/Icons/Solid/SMailOpen.vue";

var script$73 = defineComponent({
  name: 'SFolderDownload'
});

const _hoisted_1$73 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
const _hoisted_2$73 = /*#__PURE__*/createVNode("path", { d: "M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" }, null, -1 /* HOISTED */);
const _hoisted_3$P = /*#__PURE__*/createVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 9v4m0 0l-2-2m2 2l2-2"
}, null, -1 /* HOISTED */);

function render$73(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("svg", _hoisted_1$73, [
    _hoisted_2$73,
    _hoisted_3$P
  ]))
}

script$73.render = render$73;
script$73.__file = "lib/components/Icons/Solid/SFolderDownload.vue";

export { script$5 as OAcademicCap, script$16 as OAdjustments, script$2I as OAnnotation, script$1e as OArchive, script$h as OArrowCircleDown, script$14 as OArrowCircleLeft, script$D as OArrowCircleRight, script$1P as OArrowCircleUp, script$1q as OArrowDown, script$3f as OArrowLeft, script$15 as OArrowNarrowDown, script$2W as OArrowNarrowLeft, script$2Z as OArrowNarrowRight, script$e as OArrowNarrowUp, script$2g as OArrowRight, script$3q as OArrowUp, script$1T as OArrowsExpand, script$F as OAtSymbol, script$31 as OBackspace, script$2z as OBadgeCheck, script$1W as OBan, script$2b as OBeaker, script$3m as OBell, script$2D as OBookOpen, script$2P as OBookmark, script$38 as OBookmarkAlt, script$6 as OBriefcase, script$39 as OCake, script as OCalculator, script$y as OCalendar, script$f as OCamera, script$1z as OCash, script$22 as OChartBar, script$27 as OChartPie, script$1d as OChartSquareBar, script$37 as OChat, script$1p as OChatAlt, script$1I as OChatAlt2, script$3s as OCheck, script$2c as OCheckCircle, script$$ as OChevronDoubleDown, script$2m as OChevronDoubleLeft, script$2n as OChevronDoubleRight, script$1r as OChevronDoubleUp, script$26 as OChevronDown, script$1U as OChevronLeft, script$1A as OChevronRight, script$3a as OChevronUp, script$Q as OChip, script$2C as OClipboard, script$1K as OClipboardCheck, script$3k as OClipboardCopy, script$2v as OClipboardList, script$A as OClock, script$2w as OCloud, script$2s as OCloudDownload, script$R as OCloudUpload, script$1m as OCode, script$2R as OCog, script$1k as OCollection, script$b as OColorSwatch, script$1u as OCreditCard, script$10 as OCube, script$29 as OCubeTransparent, script$2T as OCurrencyBangladeshi, script$1a as OCurrencyDollar, script$Z as OCurrencyEuro, script$1G as OCurrencyPound, script$c as OCurrencyRupee, script$T as OCurrencyYen, script$3g as OCursorClick, script$3 as ODatabase, script$13 as ODesktopComputer, script$1L as ODeviceMobile, script$N as ODeviceTablet, script$1D as ODocument, script$2E as ODocumentAdd, script$m as ODocumentDownload, script$24 as ODocumentDuplicate, script$3h as ODocumentRemove, script$11 as ODocumentReport, script$12 as ODocumentSearch, script$1F as ODocumentText, script$2K as ODotsCircleHorizontal, script$1y as ODotsHorizontal, script$3l as ODotsVertical, script$2_ as ODownload, script$1X as ODuplicate, script$x as OEmojiHappy, script$35 as OEmojiSad, script$36 as OExclamation, script$2y as OExclamationCircle, script$1_ as OExternalLink, script$X as OEye, script$w as OEyeOff, script$2A as OFastForward, script$n as OFilm, script$i as OFilter, script$z as OFingerPrint, script$2B as OFire, script$1 as OFlag, script$2Y as OFolder, script$W as OFolderAdd, script$3x as OFolderDownload, script$2J as OFolderOpen, script$1O as OFolderRemove, script$_ as OGift, script$3p as OGlobe, script$2o as OGlobeAlt, script$2$ as OHand, script$19 as OHashtag, script$K as OHeart, script$1M as OHome, script$2u as OIdentification, script$34 as OInbox, script$33 as OInboxIn, script$3r as OInformationCircle, script$1j as OKey, script$1N as OLibrary, script$2G as OLightBulb, script$3o as OLightningBolt, script$1o as OLink, script$J as OLocationMarker, script$2p as OLockClosed, script$k as OLockOpen, script$2i as OLogin, script$1x as OLogout, script$18 as OMail, script$3w as OMailOpen, script$a as OMap, script$30 as OMenu, script$1i as OMenuAlt1, script$1c as OMenuAlt2, script$2F as OMenuAlt3, script$7 as OMenuAlt4, script$H as OMicrophone, script$M as OMinus, script$1R as OMinusCircle, script$3c as OMinusSm, script$B as OMoon, script$1f as OMusicNote, script$2 as ONewspaper, script$o as OOfficeBuilding, script$20 as OPaperAirplane, script$1Y as OPaperClip, script$r as OPause, script$Y as OPencil, script$2f as OPencilAlt, script$1J as OPhone, script$2N as OPhoneIncoming, script$j as OPhoneMissedCall, script$2d as OPhoneOutgoing, script$1t as OPhotograph, script$C as OPlay, script$3v as OPlus, script$S as OPlusCircle, script$g as OPlusSm, script$1H as OPresentationChartBar, script$1g as OPresentationChartLine, script$G as OPrinter, script$1Z as OPuzzle, script$1w as OQrcode, script$3b as OQuestionMarkCircle, script$1l as OReceiptRefund, script$p as OReceiptTax, script$2H as ORefresh, script$q as OReply, script$I as ORewind, script$d as ORss, script$s as OSave, script$3j as OSaveAs, script$P as OScale, script$2l as OScissors, script$O as OSearch, script$E as OSearchCircle, script$1C as OSelector, script$u as OServer, script$2X as OShare, script$2r as OShieldCheck, script$2t as OShieldExclamation, script$2a as OShoppingBag, script$21 as OShoppingCart, script$1Q as OSortAscending, script$1b as OSortDescending, script$2x as OSparkles, script$U as OSpeakerphone, script$23 as OStar, script$1s as OStatusOffline, script$1B as OStatusOnline, script$t as OStop, script$2h as OSun, script$2q as OSupport, script$3u as OSwitchHorizontal, script$17 as OSwitchVertical, script$1V as OTable, script$8 as OTag, script$l as OTemplate, script$2L as OTerminal, script$3d as OThumbDown, script$2S as OThumbUp, script$3t as OTicket, script$2e as OTranslate, script$1E as OTrash, script$3i as OTrendingDown, script$L as OTrendingUp, script$V as OTruck, script$2k as OUpload, script$2M as OUser, script$9 as OUserAdd, script$2V as OUserCircle, script$25 as OUserGroup, script$2O as OUserRemove, script$28 as OUsers, script$2U as OVariable, script$4 as OVideoCamera, script$1h as OViewBoards, script$1v as OViewGrid, script$1S as OViewGridAdd, script$1n as OViewList, script$1$ as OVolumeOff, script$32 as OVolumeUp, script$v as OWifi, script$2Q as OX, script$3n as OXCircle, script$2j as OZoomIn, script$3e as OZoomOut, script$3D as SAcademicCap, script$4E as SAdjustments, script$6e as SAnnotation, script$4M as SArchive, script$3P as SArrowCircleDown, script$4C as SArrowCircleLeft, script$49 as SArrowCircleRight, script$5l as SArrowCircleUp, script$4Y as SArrowDown, script$6N as SArrowLeft, script$4D as SArrowNarrowDown, script$6s as SArrowNarrowLeft, script$6v as SArrowNarrowRight, script$3M as SArrowNarrowUp, script$5O as SArrowRight, script$6Y as SArrowUp, script$5p as SArrowsExpand, script$4b as SAtSymbol, script$6z as SBackspace, script$65 as SBadgeCheck, script$5s as SBan, script$5J as SBeaker, script$6U as SBell, script$69 as SBookOpen, script$6l as SBookmark, script$6G as SBookmarkAlt, script$3E as SBriefcase, script$6H as SCake, script$3y as SCalculator, script$44 as SCalendar, script$3N as SCamera, script$55 as SCash, script$5A as SChartBar, script$5F as SChartPie, script$4L as SChartSquareBar, script$6F as SChat, script$4X as SChatAlt, script$5e as SChatAlt2, script$6_ as SCheck, script$5K as SCheckCircle, script$4x as SChevronDoubleDown, script$5U as SChevronDoubleLeft, script$5V as SChevronDoubleRight, script$4Z as SChevronDoubleUp, script$5E as SChevronDown, script$5q as SChevronLeft, script$56 as SChevronRight, script$6I as SChevronUp, script$4m as SChip, script$68 as SClipboard, script$5g as SClipboardCheck, script$6S as SClipboardCopy, script$61 as SClipboardList, script$46 as SClock, script$62 as SCloud, script$5_ as SCloudDownload, script$4n as SCloudUpload, script$4U as SCode, script$6n as SCog, script$4S as SCollection, script$3J as SColorSwatch, script$50 as SCreditCard, script$4y as SCube, script$5H as SCubeTransparent, script$6p as SCurrencyBangladeshi, script$4I as SCurrencyDollar, script$4v as SCurrencyEuro, script$5c as SCurrencyPound, script$3K as SCurrencyRupee, script$4p as SCurrencyYen, script$6O as SCursorClick, script$3B as SDatabase, script$4B as SDesktopComputer, script$5h as SDeviceMobile, script$4j as SDeviceTablet, script$59 as SDocument, script$6a as SDocumentAdd, script$3U as SDocumentDownload, script$5C as SDocumentDuplicate, script$6P as SDocumentRemove, script$4z as SDocumentReport, script$4A as SDocumentSearch, script$5b as SDocumentText, script$6g as SDotsCircleHorizontal, script$54 as SDotsHorizontal, script$6T as SDotsVertical, script$6w as SDownload, script$5t as SDuplicate, script$43 as SEmojiHappy, script$6D as SEmojiSad, script$6E as SExclamation, script$64 as SExclamationCircle, script$5w as SExternalLink, script$4t as SEye, script$42 as SEyeOff, script$66 as SFastForward, script$3V as SFilm, script$3Q as SFilter, script$45 as SFingerPrint, script$67 as SFire, script$3z as SFlag, script$6u as SFolder, script$4s as SFolderAdd, script$73 as SFolderDownload, script$6f as SFolderOpen, script$5k as SFolderRemove, script$4w as SGift, script$6X as SGlobe, script$5W as SGlobeAlt, script$6x as SHand, script$4H as SHashtag, script$4g as SHeart, script$5i as SHome, script$60 as SIdentification, script$6C as SInbox, script$6B as SInboxIn, script$6Z as SInformationCircle, script$4R as SKey, script$5j as SLibrary, script$6c as SLightBulb, script$6W as SLightningBolt, script$4W as SLink, script$4f as SLocationMarker, script$5X as SLockClosed, script$3S as SLockOpen, script$5Q as SLogin, script$53 as SLogout, script$4G as SMail, script$72 as SMailOpen, script$3I as SMap, script$6y as SMenu, script$4Q as SMenuAlt1, script$4K as SMenuAlt2, script$6b as SMenuAlt3, script$3F as SMenuAlt4, script$4d as SMicrophone, script$4i as SMinus, script$5n as SMinusCircle, script$6K as SMinusSm, script$47 as SMoon, script$4N as SMusicNote, script$3A as SNewspaper, script$3W as SOfficeBuilding, script$5y as SPaperAirplane, script$5u as SPaperClip, script$3Z as SPause, script$4u as SPencil, script$5N as SPencilAlt, script$5f as SPhone, script$6j as SPhoneIncoming, script$3R as SPhoneMissedCall, script$5L as SPhoneOutgoing, script$4$ as SPhotograph, script$48 as SPlay, script$71 as SPlus, script$4o as SPlusCircle, script$3O as SPlusSm, script$5d as SPresentationChartBar, script$4O as SPresentationChartLine, script$4c as SPrinter, script$5v as SPuzzle, script$52 as SQrcode, script$6J as SQuestionMarkCircle, script$4T as SReceiptRefund, script$3X as SReceiptTax, script$6d as SRefresh, script$3Y as SReply, script$4e as SRewind, script$3L as SRss, script$3_ as SSave, script$6R as SSaveAs, script$4l as SScale, script$5T as SScissors, script$4k as SSearch, script$4a as SSearchCircle, script$58 as SSelector, script$40 as SServer, script$6t as SShare, script$5Z as SShieldCheck, script$5$ as SShieldExclamation, script$5I as SShoppingBag, script$5z as SShoppingCart, script$5m as SSortAscending, script$4J as SSortDescending, script$63 as SSparkles, script$4q as SSpeakerphone, script$5B as SStar, script$4_ as SStatusOffline, script$57 as SStatusOnline, script$3$ as SStop, script$5P as SSun, script$5Y as SSupport, script$70 as SSwitchHorizontal, script$4F as SSwitchVertical, script$5r as STable, script$3G as STag, script$3T as STemplate, script$6h as STerminal, script$6L as SThumbDown, script$6o as SThumbUp, script$6$ as STicket, script$5M as STranslate, script$5a as STrash, script$6Q as STrendingDown, script$4h as STrendingUp, script$4r as STruck, script$5S as SUpload, script$6i as SUser, script$3H as SUserAdd, script$6r as SUserCircle, script$5D as SUserGroup, script$6k as SUserRemove, script$5G as SUsers, script$6q as SVariable, script$3C as SVideoCamera, script$4P as SViewBoards, script$51 as SViewGrid, script$5o as SViewGridAdd, script$4V as SViewList, script$5x as SVolumeOff, script$6A as SVolumeUp, script$41 as SWifi, script$6m as SX, script$6V as SXCircle, script$5R as SZoomIn, script$6M as SZoomOut };
//# sourceMappingURL=vue3-heroicons.esm.js.map
